// ===============================
// Preserve scroll position on refresh (ScrollTrigger sets scrollRestoration = "manual")
// ===============================
(function () {
  var STORAGE_KEY = 'mci_scroll_position';
  var STORAGE_URL_KEY = 'mci_scroll_url';

  function getPageKey() {
    return window.location.pathname + (window.location.search || '');
  }

  function getScrollY() {
    if (window.lenis && typeof window.lenis.scroll === 'number') return window.lenis.scroll;
    return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function saveScrollPosition() {
    try {
      var y = getScrollY();
      sessionStorage.setItem(STORAGE_KEY, String(y));
      sessionStorage.setItem(STORAGE_URL_KEY, getPageKey());
    } catch (e) {}
  }

  window.addEventListener('pagehide', saveScrollPosition);
  window.addEventListener('beforeunload', saveScrollPosition);

  function hasTransitionWrapper() {
    return document.querySelector('.about-transition-wrapper, .experience-transition-wrapper, .homepage-transition-wrapper');
  }

  document.addEventListener('DOMContentLoaded', function () {
    try {
      // Never restore scroll on transition pages; always start at top so layout isn't collapsed when refreshing from anywhere
      var hasHash = !!window.location.hash;
      if (hasTransitionWrapper() && !hasHash) {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_URL_KEY);
        if (typeof history !== 'undefined' && history.scrollRestoration) history.scrollRestoration = 'manual';
        window.scrollTo(0, 0);
        if (window.lenis && typeof window.lenis.scrollTo === 'function') window.lenis.scrollTo(0, { immediate: true });
        requestAnimationFrame(function () {
          window.scrollTo(0, 0);
          if (window.lenis && typeof window.lenis.scrollTo === 'function') window.lenis.scrollTo(0, { immediate: true });
        });
        setTimeout(function () {
          window.scrollTo(0, 0);
          if (window.lenis && typeof window.lenis.scrollTo === 'function') window.lenis.scrollTo(0, { immediate: true });
        }, 50);
        return;
      }

      var savedUrl = sessionStorage.getItem(STORAGE_URL_KEY);
      var savedY = sessionStorage.getItem(STORAGE_KEY);
      if (savedUrl !== getPageKey() || savedY === null) return;

      var y = parseInt(savedY, 10);
      if (isNaN(y) || y <= 0) return;

      function restore() {
        if (window.lenis && typeof window.lenis.scrollTo === 'function') {
          window.lenis.scrollTo(y, { immediate: true });
        } else {
          window.scrollTo(0, y);
        }
      }

      // Restore after Lenis/ScrollTrigger and layout are ready (Lenis also inits on DOMContentLoaded)
      setTimeout(restore, 0);
      requestAnimationFrame(function () {
        requestAnimationFrame(restore);
      });
      setTimeout(restore, 150);
    } catch (e) {}
  });
})();

// ===============================
// Global image lazy loading defaults
// ===============================
(function () {
  function shouldEagerLoadImage(img) {
    if (!img || typeof img.getBoundingClientRect !== 'function') return false;
    if (img.hasAttribute('data-force-lazy')) return false;
    if (img.hasAttribute('fetchpriority') && img.getAttribute('fetchpriority') === 'high') return true;
    if (img.hasAttribute('data-lcp') || img.classList.contains('lcp-image')) return true;

    var rect = img.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    if (!viewportHeight || !viewportWidth) return false;

    var withinVertical = rect.top < viewportHeight * 1.1 && rect.bottom > 0;
    var withinHorizontal = rect.left < viewportWidth && rect.right > 0;
    return withinVertical && withinHorizontal;
  }

  function applyImageLoadingDefaults(scope) {
    if (!scope || !scope.querySelectorAll) return;

    scope.querySelectorAll('img').forEach(function (img) {
      // Only run the viewport check (getBoundingClientRect) when no explicit
      // loading attribute is present. Images with loading="lazy" already set by
      // server-side code are intentionally lazy — upgrading them forces layout
      // (getBoundingClientRect), causing forced reflows that delay LCP paint.
      if (!img.hasAttribute('loading')) {
        var eager = shouldEagerLoadImage(img);
        img.setAttribute('loading', eager ? 'eager' : 'lazy');
        if (eager && !img.hasAttribute('fetchpriority')) {
          img.setAttribute('fetchpriority', 'high');
        }
      }

      if (!img.hasAttribute('decoding')) {
        img.setAttribute('decoding', 'async');
      }
    });
  }

  function applyNodeDefaults(node) {
    if (!(node instanceof Element)) return;
    if (node.tagName === 'IMG') {
      if (!node.hasAttribute('loading')) {
        var eager = shouldEagerLoadImage(node);
        node.setAttribute('loading', eager ? 'eager' : 'lazy');
        if (eager && !node.hasAttribute('fetchpriority')) {
          node.setAttribute('fetchpriority', 'high');
        }
      }
      if (!node.hasAttribute('decoding')) {
        node.setAttribute('decoding', 'async');
      }
      return;
    }

    applyImageLoadingDefaults(node);
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyImageLoadingDefaults(document);

    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          applyNodeDefaults(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();

// ===============================
// Header Hide/Show On Scroll
// ===============================
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var header = document.getElementById('header');
    if (!header) return;

    var isCommunityPage = document.body.classList.contains('page-template-template-community')
      || document.body.classList.contains('page-template-template-community-php')
      || !!document.querySelector('.banner--community');
    if (isCommunityPage) return;

    var prefersReduced = false;
    try {
      prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (_) {}

    if (prefersReduced) {
      header.classList.add('is-visible');
      return;
    }

    var lastY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    var enabled = false;
    var ticking = false;

    // enable scroll behavior after initial intro animation
    setTimeout(function(){
      enabled = true;
      header.classList.add('is-visible');
      lastY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    }, 1000);

    function update(){
      if (!enabled){ ticking = false; return; }
      var currentY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      var isMenuOpen = !!(document.querySelector('.hamburger-menu') && document.querySelector('.hamburger-menu').classList.contains('is-open'));
      var nearTop = currentY <= 50;
      var delta = Math.abs(currentY - lastY);

      if (delta < 5){ ticking = false; return; }

      if (isMenuOpen){
        header.classList.remove('is-hidden');
        header.classList.add('is-visible');
        lastY = currentY; ticking = false; return;
      }

      if (document.body.classList.contains('hp-craft-video-pin-active')) {
        header.classList.remove('is-visible');
        header.classList.add('is-hidden');
        lastY = currentY;
        ticking = false;
        return;
      }

      var down = currentY > lastY;
      var passed = currentY > 100;
      if (down && passed && !nearTop){
        header.classList.remove('is-visible');
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
        header.classList.add('is-visible');
      }
      lastY = currentY; ticking = false;
    }

    window.addEventListener('scroll', function(){
      if (!ticking && enabled){
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  });
})();

// ===============================
// Burger Menu / Dropdown
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Header initial slide-in on load
    (function(){
      var header = document.getElementById("header");
      var homepageBannerContent = document.querySelector(".hp_banner_content.fade-element");
      if (!header && !homepageBannerContent) return;
      var prefersReduced = false;
      try {
        prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (_) {}
      if (prefersReduced) {
        if (header) {
          header.classList.remove('fade-out');
          header.classList.add('fade-in');
        }
        if (homepageBannerContent) {
          homepageBannerContent.classList.remove('fade-out');
          homepageBannerContent.classList.add('fade-in');
        }
        return;
      }
      // Header slides in quickly
      setTimeout(function(){
        if (header) {
          header.classList.remove('fade-out');
          header.classList.add('fade-in');
        }
      }, 50);
      // CSS animation handles initial reveal — JS only locks in end state immediately
      if (homepageBannerContent) {
        homepageBannerContent.classList.remove('fade-out');
        homepageBannerContent.classList.add('fade-in');
      }
    })();

    const headerCtaMenu = document.querySelector(".header-cta-menu");
    const hamburgerMenu = document.querySelector(".hamburger-menu");
    const hamburgerMenuClose = document.querySelector(".hamburger-menu-close");
    const hamburgerMenuImg = document.querySelector(".hamburger-menu-img");
    const hamburgerMenuItems = document.querySelector(".hamburger-menu-items");

    // Simpler, non-jumpy scroll lock that works with Lenis and transition pages
    function lockBodyScroll() {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      if (window.lenis && typeof window.lenis.stop === "function") {
        window.lenis.stop();
      }
    }

    function unlockBodyScroll() {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      if (window.lenis && typeof window.lenis.start === "function") {
        window.lenis.start();
      }
    }

    function closeHamburgerMenu() {
      if (!hamburgerMenu || !hamburgerMenu.classList.contains("is-open")) return;
      hamburgerMenu.classList.add("is-closing");
      hamburgerMenu.classList.remove("is-open");
      if (headerCtaMenu) headerCtaMenu.classList.remove("active");
      unlockBodyScroll();
      setTimeout(function () {
        hamburgerMenu.classList.remove("is-closing");
      }, 900);
    }

    if (headerCtaMenu) {
      headerCtaMenu.addEventListener("click", function () {
        if (hamburgerMenu) {
          if (hamburgerMenu.classList.contains("is-open")) {
            closeHamburgerMenu();
          } else {
            lockBodyScroll();
            this.classList.add("active");
            hamburgerMenu.classList.add("is-open");
          }
        }
      });
    }

    if (hamburgerMenu) {
      hamburgerMenu.addEventListener("click", function (e) {
        const clickedInsideMenuImage = !!e.target.closest(".hamburger-menu-img");
        const clickedInsideMenuItems = !!e.target.closest(".hamburger-menu-items");

        if (!clickedInsideMenuImage && !clickedInsideMenuItems) {
          closeHamburgerMenu();
        }
      });
    }

    if (hamburgerMenuClose) {
      hamburgerMenuClose.addEventListener("click", function () {
        closeHamburgerMenu();
      });
    }

    document.addEventListener("click", function (e) {
      if (!hamburgerMenu || !hamburgerMenu.classList.contains("is-open")) return;

      if (
        e.target.closest(".header-cta-menu") ||
        (hamburgerMenu && hamburgerMenu.contains(e.target)) ||
        (hamburgerMenuImg && hamburgerMenuImg.contains(e.target)) ||
        (hamburgerMenuItems && hamburgerMenuItems.contains(e.target))
      ) {
        return;
      }

      closeHamburgerMenu();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && hamburgerMenu && hamburgerMenu.classList.contains("is-open")) {
        closeHamburgerMenu();
      }
    });
  });
})();

// ===============================
// Wishlist Action Bar (Share / Download PDF / Enquiry)
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const shareBtn = document.getElementById("wishlist-share");
    const downloadBtn = document.getElementById("wishlist-download-pdf");
    const actionsBar = document.querySelector(".wishlist-actions");
    const wishlistSection = document.querySelector(".wishlist-content");
    const pushWishlistPdfDownloadEvent = (method) => {
      if (!Array.isArray(window.dataLayer)) return;

      window.dataLayer.push({
        event: "wishlist_pdf_download",
        page_type: "wishlist",
        download_method: method
      });
    };

    // ===== SHARE (dropdown: WhatsApp, copy link, more options) =====
    if (shareBtn) {
      const shareMenu = document.getElementById("wishlist-share-menu");
      const shareFeedback = shareMenu ? shareMenu.querySelector(".wishlist-share-feedback") : null;
      let shareState = { url: "", message: "", title: "Wishlist" };

      function collectWishlistShareProductIds() {
        const productIdSet = new Set();
        const removeSelectors = [
          ".wishlist-cart-content a.remove[data-product_id]",
          ".wishlist-cart-content a.remove[data-product-id]",
          "form.woocommerce-cart-form a.remove[data-product_id]",
          "form.woocommerce-cart-form a.remove[data-product-id]"
        ];

        removeSelectors.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            const raw =
              el.getAttribute("data-product_id") ||
              el.getAttribute("data-product-id");
            const pid = parseInt(raw, 10);
            if (!isNaN(pid) && pid > 0) productIdSet.add(pid);
          });
        });

        if (productIdSet.size === 0 && typeof window.mciGetWishlistShareProductIds === "function") {
          window.mciGetWishlistShareProductIds().forEach(function (id) {
            const pid = parseInt(id, 10);
            if (!isNaN(pid) && pid > 0) productIdSet.add(pid);
          });
        }

        if (productIdSet.size === 0) {
          try {
            const raw = window.sessionStorage.getItem("mci_wishlist_state_v1");
            if (raw) {
              const parsed = JSON.parse(raw);
              const ids = parsed && Array.isArray(parsed.productIds) ? parsed.productIds : [];
              ids.forEach(function (id) {
                const pid = parseInt(id, 10);
                if (!isNaN(pid) && pid > 0) productIdSet.add(pid);
              });
            }
          } catch (_) {}
        }

        return productIdSet;
      }

      async function buildWishlistSharePayload(shareButton) {
        const ajaxUrl =
          typeof window.mciWishlist !== "undefined" && window.mciWishlist.ajax_url
            ? window.mciWishlist.ajax_url
            : "";
        const ajaxNonce =
          typeof window.mciWishlist !== "undefined" && window.mciWishlist.nonce
            ? window.mciWishlist.nonce
            : "";
        const baseShareUrl =
          (typeof window.mciWishlist !== "undefined" && window.mciWishlist.wishlist_url) ||
          shareButton.getAttribute("data-share-url") ||
          window.location.href;
        const productIdSet = collectWishlistShareProductIds();

        let shareUrl = baseShareUrl;
        if (productIdSet.size > 0) {
          try {
            const shareObj = new URL(baseShareUrl, window.location.origin);
            shareObj.searchParams.set("wl", Array.from(productIdSet).join(","));
            shareUrl = shareObj.toString();
          } catch (_) {}
        }

        if (ajaxUrl && ajaxNonce) {
          try {
            const wlPayload = Array.from(productIdSet).join(",");
            const shortLinkRes = await $.post(ajaxUrl, {
              action: "mci_wishlist_share_link",
              wl: wlPayload,
              nonce: ajaxNonce
            });
            if (
              shortLinkRes &&
              shortLinkRes.success &&
              shortLinkRes.data &&
              shortLinkRes.data.short_url
            ) {
              shareUrl = shortLinkRes.data.short_url;
            }
          } catch (_) {}
        }

        return {
          url: shareUrl,
          message: "Check out my wishlist: " + shareUrl,
          title: document.title || "Wishlist"
        };
      }

      function openWhatsAppWithMessage(message) {
        const encoded = encodeURIComponent(message);
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || "");
        const url = isMobile
          ? "whatsapp://send?text=" + encoded
          : "https://web.whatsapp.com/send?text=" + encoded;

        const link = document.createElement("a");
        link.href = url;
        link.rel = "noopener noreferrer";
        if (!isMobile) {
          link.target = "_blank";
        }
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

      function showShareFeedback(text) {
        if (!shareFeedback) return;
        shareFeedback.textContent = text;
        shareFeedback.hidden = false;
        window.setTimeout(function () {
          shareFeedback.hidden = true;
          shareFeedback.textContent = "";
        }, 2200);
      }

      function openShareMenu() {
        if (!shareMenu) return;
        shareMenu.classList.add("is-open");
        shareMenu.setAttribute("aria-hidden", "false");
        shareBtn.setAttribute("aria-expanded", "true");
      }

      function closeShareMenu() {
        if (!shareMenu) return;
        shareMenu.classList.remove("is-open");
        shareMenu.setAttribute("aria-hidden", "true");
        shareBtn.setAttribute("aria-expanded", "false");
        if (shareFeedback) {
          shareFeedback.hidden = true;
          shareFeedback.textContent = "";
        }
      }

      function isShareMenuOpen() {
        return shareMenu && shareMenu.classList.contains("is-open");
      }

      async function copyShareLink(url) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
          return true;
        }

        const input = document.createElement("textarea");
        input.value = url;
        input.setAttribute("readonly", "");
        input.style.position = "fixed";
        input.style.left = "-9999px";
        document.body.appendChild(input);
        input.select();
        let copied = false;
        try {
          copied = document.execCommand("copy");
        } catch (_) {}
        document.body.removeChild(input);
        return copied;
      }

      function handleShareAction(action) {
        const url = shareState.url;
        const message = shareState.message;
        const title = shareState.title;

        if (!url) return;

        if (action === "whatsapp") {
          openWhatsAppWithMessage(message);
          closeShareMenu();
          return;
        }

        if (action === "copy") {
          copyShareLink(url)
            .then(function (ok) {
              if (ok) {
                showShareFeedback("Link copied to clipboard.");
                shareBtn.classList.add("shared");
              } else {
                window.prompt("Copy this wishlist link:", url);
              }
            })
            .catch(function () {
              window.prompt("Copy this wishlist link:", url);
            });
          return;
        }

        if (action === "more") {
          if (navigator.share) {
            navigator
              .share({ title: title, text: "Check out my wishlist", url: url })
              .then(function () {
                closeShareMenu();
              })
              .catch(function (err) {
                if (!err || err.name !== "AbortError") {
                  copyShareLink(url).then(function (ok) {
                    if (ok) showShareFeedback("Link copied to clipboard.");
                  });
                }
              });
            return;
          }

          copyShareLink(url).then(function (ok) {
            if (ok) {
              showShareFeedback("Link copied to clipboard.");
            } else {
              window.prompt("Copy this wishlist link:", url);
            }
          });
        }
      }

      if (shareMenu) {
        shareMenu.querySelectorAll("[data-share-action]").forEach(function (btn) {
          btn.addEventListener("click", function (e) {
            e.stopPropagation();
            handleShareAction(btn.getAttribute("data-share-action"));
          });
        });
      }

      document.addEventListener("click", function (event) {
        if (!isShareMenuOpen()) return;
        const wrap = shareBtn.closest(".wishlist-share-wrap");
        if (wrap && !wrap.contains(event.target)) {
          closeShareMenu();
        }
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && isShareMenuOpen()) {
          closeShareMenu();
        }
      });

      shareBtn.addEventListener("click", async function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (isShareMenuOpen()) {
          closeShareMenu();
          return;
        }

        shareBtn.disabled = true;
        try {
          shareState = await buildWishlistSharePayload(this);
          openShareMenu();
        } finally {
          shareBtn.disabled = false;
        }
      });
    }

    // ===== DOWNLOAD (server-rendered PDF) =====
    // Opens ?wishlist_pdf=1 in a new tab — the server renders the wishlist
    // through Dompdf and streams back a real PDF (Content-Type: application/pdf,
    // inline disposition), so the new tab shows the finished file directly in
    // the browser's native PDF viewer. No print dialog step required.

    if (downloadBtn) {
      downloadBtn.addEventListener("click", function (e) {
        e.preventDefault();

        var pdfUrl = new URL(window.location.href);
        pdfUrl.searchParams.set("wishlist_pdf", "1");
        window.open(pdfUrl.toString(), "_blank", "noopener");

        pushWishlistPdfDownloadEvent("server_pdf");
      });
    }

    // ===== ACTION BAR VISIBILITY =====
    if (actionsBar && wishlistSection) {
      const minHeight = 150;

      const updateActionsVisibility = () => {
        const sectionHeight = wishlistSection.offsetHeight;

        if (sectionHeight < minHeight) {
          actionsBar.classList.add("is-hidden");
          return;
        }

        const sectionRect = wishlistSection.getBoundingClientRect();
        const vvHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        const barHeight = actionsBar.offsetHeight;

        // Hide only when the wishlist section has scrolled above where the bar sits,
        // meaning the bar would float over the footer. On iOS, vvHeight correctly
        // reflects the visual area excluding browser chrome, so this never fires
        // falsely just because the section is shorter than the full layout viewport.
        const barTopEdge = vvHeight - barHeight;
        const sectionReachesBar = sectionRect.bottom > barTopEdge;

        if (sectionReachesBar) {
          actionsBar.classList.remove("is-hidden");
        } else {
          actionsBar.classList.add("is-hidden");
        }
      };

      updateActionsVisibility();
      window.addEventListener("scroll", updateActionsVisibility, { passive: true });
      window.addEventListener("resize", updateActionsVisibility, { passive: true });
      // iOS browser chrome shows/hides dynamically — visualViewport fires when it changes
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", updateActionsVisibility);
      }
      if ("ResizeObserver" in window) {
        new ResizeObserver(updateActionsVisibility).observe(wishlistSection);
      }
    }
  });
})();

// ===============================
// Popup Logic
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const popup = document.getElementById("custom-popup");
    if (!popup) return;

    const closeButton = popup.querySelector(".popup-close");
    if (!closeButton) return;

    function closePopup() {
      popup.classList.remove("active");
    }

    closeButton.addEventListener("click", closePopup);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closePopup();
      }
    });

    window.openPopup = function () {
      popup.classList.add("active");
    };
  });
})();

// ===============================
// Counter Section Observer
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector(".counter-section");
    if (!section) return;

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCounters();
            observerInstance.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(section);
  });
})();

// ===============================
// Logo Marquee Slider (Splide)
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const logoSlider = document.querySelector(".logo-slider");
    if (!logoSlider) return;

    new Splide(logoSlider, {
      type: "loop",
      perPage: 5,
      focus: "center",
      gap: "1rem",
      pagination: false,
      arrows: false,
      autoplay: true,
      interval: 2000,
    }).mount();
  });
})();

// ===============================
// Image Slider (Splide)
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const imageSlider = document.querySelector(".image-slider");
    if (!imageSlider) return;

    new Splide(imageSlider, {
      type: "loop",
      perPage: 3,
      arrows: true,
      pagination: false,
    }).mount();
  });
})();


// ===============================
// Counter Number Animation
// ===============================

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll(".counter");
    const section = document.querySelector(".counters-section");
    const animateCounters = () => {
      if (counters.length > 0) {
        counters.forEach((counter) => {
          const target = +counter.innerText;
          counter.innerText = "0";
          const updateCount = () => {
            const count = +counter.innerText;
            const increment = target / 300;
            if (count < target) {
              counter.innerText = Math.ceil(count + increment);
              setTimeout(updateCount, 1);
            } else {
              counter.innerText = target;
            }
          };
          updateCount();
        });
      }
    };
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCounters();
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (section) {
      observer.observe(section);
    }
  });
})();


// ===============================
// Explore Video Animation
// ===============================
(function () {
  const exploreBanner = document.querySelector(".explore-banner");
  if (exploreBanner) {
    document.addEventListener("DOMContentLoaded", function () {
      gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
      const video = document.getElementById("scrollVideo");
      const spacer = document.getElementById("scrollSpacer");
      const videoSection = document.querySelector(".video-section");
      gsap.set([".background-overlay-video"], { autoAlpha: 1 });
      let scrollEnabled = false;
      let hasBeenClicked = false;
      let scrollTrigger = null;
      let scrollHeight = 0;
      let duration = 0;
      video.addEventListener("loadedmetadata", () => {
        duration = video.duration;
        const pixelsPerSecond = 300;
        scrollHeight = duration * pixelsPerSecond;
        spacer.style.height = `${scrollHeight}px`;
        video.style.cursor = "pointer";
        video.style.pointerEvents = "auto";
        video.style.zIndex = "10";
      });
      function showFrameTextAt(time) {
        const frameOne = document.querySelector(".frame-one-text");
        const frameTwo = document.querySelector(".frame-two-text");
        const frameThree = document.querySelector(".frame-three-text");
        const frameOneTop = document.querySelector(".frame-one-text-top");
        const frameTwoTop = document.querySelector(".frame-two-text-top");
        const frameThreeTop = document.querySelector(".frame-three-text-top");
        const overlay = document.querySelector(".background-overlay-video");
        const frameTextContainer = document.querySelector(
          ".frame-text-container"
        );
        [frameOne, frameTwo, frameThree].forEach((el) => {
          if (el) el.classList.remove("visible");
        });
        if (overlay) overlay.style.display = "none";
        if (frameTextContainer) frameTextContainer.style.zIndex = "";
        if (frameOneTop) frameOneTop.style.opacity = "0";
        if (frameTwoTop) frameTwoTop.style.opacity = "0";
        if (frameThreeTop) frameThreeTop.style.opacity = "0";
        function inWindow(start, end) {
          return time >= start && time < end;
        }
        if (inWindow(1.0, 2.0)) {
          if (frameOne) frameOne.classList.add("visible");
          if (frameOneTop) frameOneTop.style.opacity = "0";
          if (overlay) {
            overlay.style.zIndex = "3";
            overlay.style.display = "block";
          }
          if (frameTextContainer) frameTextContainer.style.zIndex = "4";
        } else if (time >= 2.0 && time < 2.8) {
          if (frameOneTop) frameOneTop.style.opacity = "1";
        }
        if (inWindow(2.8, 3.8)) {
          if (frameTwo) frameTwo.classList.add("visible");
          if (frameTwoTop) frameTwoTop.style.opacity = "0";
          if (overlay) {
            overlay.style.zIndex = "3";
            overlay.style.display = "block";
          }
          if (frameTextContainer) frameTextContainer.style.zIndex = "4";
        } else if (time >= 3.8 && time < 9.0) {
          if (frameTwoTop) frameTwoTop.style.opacity = "1";
        }
        if (inWindow(9.0, 10.0)) {
          if (frameThree) frameThree.classList.add("visible");
          if (frameThreeTop) frameThreeTop.style.opacity = "0";
          if (overlay) {
            overlay.style.zIndex = "3";
            overlay.style.display = "block";
          }
          if (frameTextContainer) frameTextContainer.style.zIndex = "4";
        } else if (time >= 10.0) {
          if (frameThreeTop) frameThreeTop.style.opacity = "1";
        }
      }
      let playInterval = null;
      const handleVideoClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (hasBeenClicked) return;
        hasBeenClicked = true;
        video.style.zIndex = "1";
        if (!scrollTrigger) {
          scrollTrigger = ScrollTrigger.create({
            trigger: ".video-section",
            start: "top top",
            end: `+=${scrollHeight}`,
            pin: true,
            scrub: false,
            onUpdate: () => {},
          });
        }
        video.currentTime = 0;
        await video.play();
        playInterval = setInterval(() => {
          showFrameTextAt(video.currentTime);
          if (video.currentTime >= 1) {
            video.pause();
            video.currentTime = 1;
            clearInterval(playInterval);
            video.style.zIndex = "1";
            scrollEnabled = true;
            scrollTrigger.kill();
            scrollTrigger = ScrollTrigger.create({
              trigger: ".video-section",
              start: "top top",
              end: `+=${scrollHeight}`,
              pin: true,
              scrub: 0.1,
              onUpdate: (self) => {
                if (scrollEnabled && hasBeenClicked) {
                  const t = self.progress * (duration - 0.8) + 0.8;
                  video.currentTime = t;
                  showFrameTextAt(t);
                }
              },
            });
          }
        }, 50);
        const playOverlay = document.querySelector(".video-play-overlay");
        if (playOverlay) {
          playOverlay.classList.add("fading-out");
          setTimeout(() => playOverlay.remove(), 600);
        }
      };
      video.addEventListener("click", handleVideoClick);
      videoSection.addEventListener("click", (e) => {
        if (e.target === video || video.contains(e.target)) {
          handleVideoClick(e);
        }
      });
    });
  }
})();

// ===============================
// Catalogue Popup (Auto PDF Attach)
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const openBtn = document.getElementById("open-catalogue-form");
    const popup = document.getElementById("catalogue-popup");
    const closeBtn = document.querySelector(".catalogue-close");
    if (!openBtn || !popup || !closeBtn) return;
    openBtn.addEventListener("click", async function (e) {
      e.preventDefault();
      popup.style.display = "block";
      const pdfUrl = openBtn.getAttribute("data-file");
      if (!pdfUrl) return;
      try {
        const response = await fetch(pdfUrl);
        const blob = await response.blob();
        const file = new File([blob], "Product-Catalogue.pdf", {
          type: "application/pdf",
        });
        const fileInput = document.getElementById("auto-pdf");
        if (!fileInput) return;
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        fileInput.files = dataTransfer.files;
      } catch (error) {}
    });
    closeBtn.addEventListener("click", function () {
      popup.style.display = "none";
    });
    window.addEventListener("click", function (e) {
      if (e.target === popup) {
        popup.style.display = "none";
      }
    });
  });
})();

// ===============================
// Wishlist Enquiry Popup
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var modal    = document.getElementById("enquiry-popup");
    var openBtn  = document.getElementById("open-enquiry-popup");
    var closeBtn = document.querySelector(".enquiry-close");

    if (!modal) return;

    // --- Open / close ---
    window.closeEnquiryPopup = function () {
      modal.classList.remove("active");
      document.body.classList.remove("no-scroll");
      var f = document.getElementById("mci-enquiry-form");
      var r = document.getElementById("mci-enquiry-response");
      if (f) { f.reset(); f.style.display = ""; f.querySelectorAll(".is-invalid").forEach(function(el){ el.classList.remove("is-invalid"); }); f.querySelectorAll(".mci-enquiry-form__error").forEach(function(el){ el.style.display = "none"; el.textContent = ""; }); }
      if (r) { r.hidden = true; r.textContent = ""; }
    };

    if (openBtn) {
      openBtn.addEventListener("click", function (e) {
        e.preventDefault();
        modal.classList.add("active");
        document.body.classList.add("no-scroll");
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", window.closeEnquiryPopup);
    }

    window.addEventListener("click", function (e) {
      if (e.target === modal) window.closeEnquiryPopup();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("active")) window.closeEnquiryPopup();
    });

    // Thank you popup close
    var tyPopup = document.getElementById("enquiry-thankyou-popup");
    function closeTyPopup() {
      if (tyPopup) tyPopup.classList.remove("active");
      document.body.classList.remove("no-scroll");
    }
    if (tyPopup) {
      tyPopup.addEventListener("click", function (e) {
        if (e.target === tyPopup) closeTyPopup();
      });
      var tyCloseBtn = tyPopup.querySelector(".enquiry-thankyou-popup__close");
      if (tyCloseBtn) tyCloseBtn.addEventListener("click", closeTyPopup);
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && tyPopup && tyPopup.classList.contains("active")) closeTyPopup();
    });

    // --- Enquiry form ---
    var form      = document.getElementById("mci-enquiry-form");
    var response  = document.getElementById("mci-enquiry-response");
    if (!form) return;

    var ajaxUrl    = (typeof mciWishlist !== "undefined" && mciWishlist.ajax_url)    ? mciWishlist.ajax_url    : "/wp-admin/admin-ajax.php";
    var nonce      = (typeof mciWishlist !== "undefined" && mciWishlist.enquiry_nonce) ? mciWishlist.enquiry_nonce : "";

    function showError(input, msg) {
      var err = input.closest(".mci-enquiry-form__field").querySelector(".mci-enquiry-form__error");
      input.classList.add("is-invalid");
      if (err) { err.textContent = msg; err.style.display = "block"; }
    }

    function clearError(input) {
      var err = input.closest(".mci-enquiry-form__field") && input.closest(".mci-enquiry-form__field").querySelector(".mci-enquiry-form__error");
      input.classList.remove("is-invalid");
      if (err) { err.textContent = ""; err.style.display = "none"; }
    }

    function validateForm() {
      var valid     = true;
      var firstName = form.querySelector("[name='enquiry_first_name']");
      var lastName  = form.querySelector("[name='enquiry_last_name']");
      var email     = form.querySelector("[name='enquiry_email']");
      var phone     = form.querySelector("[name='enquiry_phone']");

      if (!firstName.value.trim()) { showError(firstName, "First name is required."); valid = false; } else clearError(firstName);
      if (!lastName.value.trim())  { showError(lastName,  "Last name is required.");  valid = false; } else clearError(lastName);
      if (!email.value.trim()) { showError(email, "Email address is required."); valid = false; }
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) { showError(email, "Please enter a valid email address."); valid = false; }
      else clearError(email);
      if (!phone.value.trim()) { showError(phone, "Phone number is required."); valid = false; } else clearError(phone);

      return valid;
    }

    // Clear error on input
    form.querySelectorAll("input, textarea").forEach(function (el) {
      el.addEventListener("input", function () { if (el.classList.contains("is-invalid")) clearError(el); });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!validateForm()) return;

      var submitBtn   = form.querySelector(".mci-enquiry-form__submit");
      var submitLabel = form.querySelector(".mci-enquiry-form__submit-label");
      submitBtn.disabled = true;
      submitLabel.textContent = "Sending...";
      if (response) response.hidden = true;

      var data = new FormData();
      data.append("action",             "mci_send_enquiry");
      data.append("nonce",              nonce);
      data.append("enquiry_first_name", form.querySelector("[name='enquiry_first_name']").value.trim());
      data.append("enquiry_last_name",  form.querySelector("[name='enquiry_last_name']").value.trim());
      data.append("enquiry_email",      form.querySelector("[name='enquiry_email']").value.trim());
      data.append("enquiry_phone",      form.querySelector("[name='enquiry_phone']").value.trim());
      var msgEl = form.querySelector("[name='enquiry_message']");
      if (msgEl) data.append("enquiry_message", msgEl.value.trim());

      // Send wishlist product IDs via the globally exposed getter
      var enquiryProductIds = typeof window.mciGetWishlistShareProductIds === "function"
        ? window.mciGetWishlistShareProductIds()
        : [];
      enquiryProductIds.forEach(function(pid) { data.append("product_ids[]", pid); });

      fetch(ajaxUrl, { method: "POST", body: data })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.success) {
            if (typeof window.closeEnquiryPopup === "function") window.closeEnquiryPopup();
            var tyPopup = document.getElementById("enquiry-thankyou-popup");
            if (tyPopup) {
              tyPopup.classList.add("active");
              document.body.classList.add("no-scroll");
            }
          } else {
            if (response) {
              response.textContent = res.data || "Something went wrong. Please try again.";
              response.className   = "mci-enquiry-form__response mci-enquiry-form__response--error";
              response.hidden      = false;
            }
            submitBtn.disabled      = false;
            submitLabel.textContent = "Send Enquiry";
          }
        })
        .catch(function () {
          if (response) {
            response.textContent = "Something went wrong. Please try again.";
            response.className   = "mci-enquiry-form__response mci-enquiry-form__response--error";
            response.hidden      = false;
          }
          submitBtn.disabled      = false;
          submitLabel.textContent = "Send Enquiry";
        });
    });
  });
})();

// ===============================
// Video Popup
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const modal = document.getElementById("videoModal");
    const iframe = document.getElementById("videoIframe");
    const videoPlayer = document.getElementById("videoPlayer");

    if (!modal || !iframe || !videoPlayer) return;

    const closeBtn = modal.querySelector(".video-modal-close");
    if (!closeBtn) return;

    // Trigger popup
    document.body.addEventListener("click", (e) => {
      const trigger = e.target.closest(".video-trigger");
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        const videoUrl = trigger.getAttribute("data-video-url");
        if (videoUrl) {
          const isDirectVideo = /\.(mp4|webm|ogg)(\?|#|$)/i.test(videoUrl);

          if (isDirectVideo) {
            iframe.style.display = "none";
            iframe.src = "";
            videoPlayer.style.display = "block";
            videoPlayer.src = videoUrl;
            videoPlayer.currentTime = 0;
            videoPlayer.play().catch(() => {});
          } else {
            videoPlayer.pause();
            videoPlayer.removeAttribute("src");
            videoPlayer.load();
            videoPlayer.style.display = "none";
            iframe.style.display = "block";
            var sep = videoUrl.indexOf("?") !== -1 ? "&" : "?";
            iframe.src = videoUrl + sep + "autoplay=1";
          }

          modal.classList.add("show");
        }
      }
    });

    // Close popup
    const closeModal = () => {
      modal.classList.remove("show");
      iframe.src = "";
      iframe.style.display = "block";
      videoPlayer.pause();
      videoPlayer.removeAttribute("src");
      videoPlayer.load();
      videoPlayer.style.display = "none";
    };

    closeBtn.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      if (!modal.classList.contains("show")) return;
      e.preventDefault();
      closeModal();
    });
  });
})();

// Categories grid: load thumbnails only when reasonably in view (stricter than lazy-loading.js / native lazy on dense grids)
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var wrap = document.querySelector(".categories-wrap");
    if (!wrap) return;

    var imgs = wrap.querySelectorAll("img.js-category-defer[data-cat-src]");
    if (!imgs.length) return;

    function activateCatImg(img) {
      if (!(img instanceof HTMLImageElement)) return;
      var url = img.getAttribute("data-cat-src");
      if (!url) return;
      img.setAttribute("src", url);
      img.removeAttribute("data-cat-src");
      img.classList.remove("js-category-defer");
    }

    if (!("IntersectionObserver" in window)) {
      imgs.forEach(activateCatImg);
      return;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activateCatImg(entry.target);
          obs.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -18vh 0px",
        threshold: 0.12,
      }
    );

    imgs.forEach(function (img) {
      io.observe(img);
    });
  });
})();

//Categories Image Parallax Animation
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const parallaxImages = document.querySelectorAll('.parallax-img');

    function updateParallax() {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;

      parallaxImages.forEach(img => {
        const wrapper = img.closest('.parallax-wrapper');
        const parent = wrapper ? wrapper.closest('.categories-items') : img.closest('.categories-items');
        const rect = parent.getBoundingClientRect();
        const offsetTop = rect.top + scrollTop;

        const distanceFromCenter = (scrollTop + windowHeight / 2) - (offsetTop + rect.height / 2);
        const movement = distanceFromCenter * 0.15;

        const target = wrapper || img;
        target.style.setProperty('--parallax-offset', `${movement}px`);
      });

      requestAnimationFrame(updateParallax);
    }

    requestAnimationFrame(updateParallax);
  });
})();

//Categories Image Custom Cursor
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const cursor = document.getElementById("custom-cursor");
    const items = document.querySelectorAll(".categories-items");

    // Move cursor to body so no ancestor transform/stacking context affects position:fixed
    if (cursor && cursor.parentElement !== document.body) {
      document.body.appendChild(cursor);
    }

    let mouseX = 0, mouseY = 0;
    let currentX = 0, currentY = 0;

    const animate = () => {
      if (cursor) {
        currentX += (mouseX - currentX) * 0.15;
        currentY += (mouseY - currentY) * 0.15;
        cursor.style.transform = `translate(calc(${currentX}px - 50%), calc(${currentY}px - 50%))`;
      }
      requestAnimationFrame(animate);
    };
    animate();

    // Update position with scroll compensation
    document.addEventListener("mousemove", (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });

    // Cursor show/hide on hover
    items.forEach(item => {
      item.addEventListener("mouseenter", () => {
        cursor.style.opacity = 1;
        item.style.cursor = "none";
      });

      item.addEventListener("mouseleave", () => {
        cursor.style.opacity = 0;
        item.style.cursor = "";
      });
    });
  });
})();

//Mci Creation Parallax Animation
(function () {
  let observer = null;
  
  function initCreationItemsObserver() {
    // Get items that haven't been observed yet
    const items = document.querySelectorAll('.mci-creations-list .mci-creation-item:not([data-observed])');
    
    if (items.length === 0) return;
    
    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target;

            // Force reflow to ensure transition triggers
            void el.offsetWidth;

            el.classList.add('in-view');
            el.setAttribute('data-observed', 'true');
            observer.unobserve(el);
          }
        });
      }, {
        threshold: 0.01,
        // Start animation slightly before the row fully enters view (feels snappier on scroll).
        rootMargin: "0px 0px 10% 0px",
      });
    }
    
    // Get all items to calculate proper index
    const allItems = document.querySelectorAll('.mci-creations-list .mci-creation-item');
    
    items.forEach((item) => {
      const globalIndex = Array.from(allItems).indexOf(item);
      // Short capped stagger so deep rows do not wait seconds before animating.
      const staggerMs = Math.min(globalIndex * 20, 80);

      item.style.transitionDelay = `${staggerMs}ms`;
      item.setAttribute("data-observed", "true");
      observer.observe(item);
    });
  }
  
  // Expose function globally for AJAX callbacks
  window.initMciCreationItems = initCreationItemsObserver;

  document.addEventListener("DOMContentLoaded", () => {
    initCreationItemsObserver();
  });
})();

(function () {
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let enabled = false;
  let animationFrameId = null;

  const getThumbs = () => document.querySelectorAll('.mci-post-thumbnail img');
  let parallaxThumbs = getThumbs();

  const shouldEnable = () => {
    if (mediaQuery.matches) return false;
    return parallaxThumbs.length > 0;
  };

  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

  function updateParallax() {
    if (!enabled) return; // stop loop when disabled

    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;

    // Read DOM first
    const frames = [];
    parallaxThumbs.forEach(img => {
      const parent = img.closest('.mci-creation-item');
      if (!parent) return;
      const rect = parent.getBoundingClientRect();
      const offsetTop = rect.top + scrollTop;
      const distanceFromCenter = (scrollTop + windowHeight / 2) - (offsetTop + rect.height / 2);
      frames.push({ img, distanceFromCenter });
    });

    // Write styles
    const isMobile = window.innerWidth < 768;
    const isLarge = window.innerWidth >= 1440;
    const baseFactor = isMobile ? 0.03 : (isLarge ? 0.08 : 0.06); // gentler on mobile
    const maxShift = isMobile ? 20 : 40; // tighter clamp on mobile
    frames.forEach(({ img, distanceFromCenter }) => {
      const movement = clamp(distanceFromCenter * baseFactor, -maxShift, maxShift);
      img.style.transform = `translate3d(0, ${movement}px, 0)`;
    });

    animationFrameId = requestAnimationFrame(updateParallax);
  }

  function enable() {
    if (enabled) {
      // Refresh thumbs list even if already enabled
      parallaxThumbs = getThumbs();
      return;
    }
    parallaxThumbs = getThumbs();
    if (!shouldEnable()) return;
    enabled = true;
    animationFrameId = requestAnimationFrame(updateParallax);
  }

  function disable() {
    if (!enabled) return;
    enabled = false;
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }
    // reset transforms
    parallaxThumbs.forEach(img => {
      img.style.transform = '';
    });
  }

  // Expose refresh function globally for AJAX callbacks
  window.refreshParallaxThumbs = function() {
    // Always refresh the thumbs list
    parallaxThumbs = getThumbs();
    // If should be enabled and not already enabled, enable it
    if (shouldEnable() && !enabled) {
      enable();
    }
    // If already enabled, the animation loop will automatically pick up new thumbs on next frame
  };

  document.addEventListener("DOMContentLoaded", () => {
    // Init
    if (shouldEnable()) enable();

    // Respond to resize/orientation
    window.addEventListener('resize', () => {
      if (shouldEnable()) {
        enable();
      } else {
        disable();
      }
    }, { passive: true });

    // Respond to reduced motion preference changes
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', () => {
        if (mediaQuery.matches) {
          disable();
        } else {
          enable();
        }
      });
    }
  });
})();

//Resources Scroll To Section
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const navLinks = document.querySelectorAll(".resources-nav__menu li a");
    const sections = document.querySelectorAll("section[id]");

    function removeActiveClasses() {
      navLinks.forEach(link => link.classList.remove("active"));
    }

    function addActiveClass(hash) {
      navLinks.forEach(link => {
        if (link.getAttribute("href") === hash) {
          link.classList.add("active");
        }
      });
    }

    navLinks.forEach(link => {
      link.addEventListener("click", function (e) {
        const href = this.getAttribute("href");
        if (!href || !href.startsWith("#")) return;

        e.preventDefault();

        const targetId = href.slice(1);
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
          window.scrollTo({
            top: targetSection.offsetTop - 0, // Adjust offset if you have fixed headers
            behavior: "smooth"
          });
          removeActiveClasses();
          this.classList.add("active");
        }
      });
    });

    // Optional: Add active class on scroll
    window.addEventListener("scroll", () => {
      const scrollY = window.pageYOffset;

      sections.forEach(section => {
        const sectionTop = section.offsetTop - 100;
        const sectionHeight = section.offsetHeight;

        if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
          const currentId = "#" + section.getAttribute("id");
          removeActiveClasses();
          addActiveClass(currentId);
        }
      });
    });
  });
})();

// Resources & Global Search Autocomplete
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    /**
     * Attach autocomplete behaviour to a search form.
     * form: <form> element
     * input: text input inside the form
     * suggestions: container for suggestion links
     * options.context: 'resources' (posts only) or 'global' (posts + products)
     */
    function initAutocomplete(form, input, suggestions, options) {
      if (!form || !input || !suggestions) return;

      const context = (options && options.context) || "";
      let debounceTimer = null;
      let abortController = null;

      const hideSuggestions = () => {
        suggestions.innerHTML = "";
        suggestions.classList.remove("is-visible");
        input.setAttribute("aria-expanded", "false");
      };

      const renderEmpty = () => {
        suggestions.innerHTML =
          '<div class="search-suggestion-empty">No suggestions found</div>';
        suggestions.classList.add("is-visible");
        input.setAttribute("aria-expanded", "true");
      };

      const renderSuggestions = (items) => {
        suggestions.innerHTML = "";

        if (!items.length) {
          renderEmpty();
          return;
        }

        items.forEach((item) => {
          const link = document.createElement("a");
          link.className = "search-suggestion-item";
          link.href = item.url;
          link.textContent = item.title;
          link.setAttribute("role", "option");
          suggestions.appendChild(link);
        });

        suggestions.classList.add("is-visible");
        input.setAttribute("aria-expanded", "true");
      };

      const fetchSuggestions = async (term) => {
        if (term.length < 2) {
          hideSuggestions();
          return;
        }

        if (abortController) {
          abortController.abort();
        }
        abortController = new AbortController();

        try {
          const params = new URLSearchParams();
          params.set("action", "mci_search_suggestions");
          params.set("term", term);
          if (context) {
            params.set("context", context);
          }

          const ajaxUrl =
            typeof customPagination !== "undefined" &&
            customPagination &&
            customPagination.ajax_url
              ? customPagination.ajax_url
              : "/wp-admin/admin-ajax.php";

          const res = await fetch(`${ajaxUrl}?${params.toString()}`, {
            signal: abortController.signal,
          });

          if (!res.ok) throw new Error("Request failed");

          const data = await res.json();
          const payload = Array.isArray(data?.data) ? data.data : [];

          const items = payload.map((item) => ({
            title: item.title || "",
            url: item.url || "#",
            type: item.type || "",
          }));

          renderSuggestions(items);
        } catch (error) {
          if (error.name === "AbortError") return;
          hideSuggestions();
        }
      };

      const debouncedFetch = (term) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => fetchSuggestions(term), 200);
      };

      input.addEventListener("input", (e) => {
        debouncedFetch(e.target.value.trim());
      });

      input.addEventListener("focus", () => {
        const value = input.value.trim();
        if (value.length >= 2) {
          fetchSuggestions(value);
        }
      });

      document.addEventListener("click", (e) => {
        if (!form.contains(e.target)) {
          hideSuggestions();
        }
      });
    }

    // Resources page search (posts only)
    (function () {
      const form = document.querySelector(".resources-nav .search-form");
      const input = form ? form.querySelector(".search-input") : null;
      const suggestions = form
        ? form.querySelector(".search-suggestions")
        : null;

      if (form && input && suggestions) {
        initAutocomplete(form, input, suggestions, { context: "resources" });
      }
    })();

    // Global search bars (header menu search, no-results search, etc.)
    const globalForms = document.querySelectorAll(".menu-search-form");
    if (globalForms.length) {
      globalForms.forEach((form) => {
        const input = form.querySelector(".menu-search-input");
        const suggestions = form.querySelector(".search-suggestions");
        if (input && suggestions) {
          initAutocomplete(form, input, suggestions, { context: "global" });
        }
      });
    }
  });
})();

// Prevent empty global/resources searches from submitting
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const forms = document.querySelectorAll(
      ".menu-search-form, .resources-nav .search-form"
    );
    if (!forms.length) return;

    forms.forEach((form) => {
      form.addEventListener("submit", function (e) {
        const input =
          form.querySelector('input[type="search"]') ||
          form.querySelector(".search-input") ||
          form.querySelector(".menu-search-input");

        if (!input) return;

        const value = (input.value || "").trim();
        if (value === "") {
          e.preventDefault();
        }
      });
    });
  });
})();

//Woocommerce Filter
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('filters-form');
    const results = document.getElementById('product-results');
    const loader = document.getElementById('ajax-loading');
    const productCount = document.getElementById('shown-count');
    const activeFiltersContainer = document.getElementById('active-filters');
    const filterGroups = document.querySelectorAll('.filter-group');

    if (!form || !results || !loader || !productCount || !activeFiltersContainer) {
      return;
    }

    const expandGroup = group => {
      const wrapper = group.querySelector('.filter-options-wrap');
      if (!wrapper) return;
      wrapper.style.height = wrapper.scrollHeight + 'px';
      group.classList.add('active');
      wrapper.addEventListener('transitionend', function handler() {
        wrapper.style.height = 'auto';
        wrapper.removeEventListener('transitionend', handler);
      });
    };

    const collapseGroup = group => {
      const wrapper = group.querySelector('.filter-options-wrap');
      if (!wrapper) return;
      wrapper.style.height = wrapper.scrollHeight + 'px';
      requestAnimationFrame(() => {
        wrapper.style.height = '0px';
      });
      group.classList.remove('active');
    };

    filterGroups.forEach(group => {
      const header = group.querySelector('h4');
      const wrapper = group.querySelector('.filter-options-wrap');
      if (wrapper) wrapper.style.height = '0px';

      group.addEventListener('click', function (e) {
        if (e.target.closest('.filter-options-wrap')) return;
        e.stopPropagation();
        const isOpen = group.classList.contains('active');
        filterGroups.forEach(g => {
          if (g !== group) collapseGroup(g);
        });
        if (isOpen) {
          collapseGroup(group);
        } else {
          expandGroup(group);
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.filter-group')) {
        filterGroups.forEach(group => collapseGroup(group));
      }
    });

    // Store current search term
    let currentSearchTerm = '';

    const renderActiveFilters = () => {
      const checkboxes = form.querySelectorAll('input[type="checkbox"]:checked');
      activeFiltersContainer.innerHTML = '';
      const activeFiltersMobile = document.getElementById('active-filters-mobile');
      
      if (activeFiltersMobile) {
        activeFiltersMobile.innerHTML = '';
      }

      // Helper function to add content to a container
      const addToContainer = (container) => {
        // If there's a search term, show it instead of filters
        if (currentSearchTerm) {
          const searchTag = document.createElement('span');
          searchTag.className = 'search-filter-tag';
          searchTag.appendChild(document.createTextNode('Search for product: ' + currentSearchTerm));
          const closeBtn = document.createElement('span');
          closeBtn.className = 'close-search-btn';
          closeBtn.dataset.action = 'clear-search';
          closeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M8.35596 2.49609L2.33984 8.51221" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.35596 8.51221L2.33984 2.49609" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          searchTag.appendChild(closeBtn);
          container.appendChild(searchTag);
          container.style.display = 'flex';
          return;
        }

        // Show regular filters if no search
        if (checkboxes.length === 0) {
          container.style.display = 'none';
          return;
        }

        checkboxes.forEach(cb => {
          const label = form.querySelector(`label[for="${cb.id}"]`);
          const tag = document.createElement('span');
          tag.className = 'filter-tag';
          tag.innerHTML = `
            ${label ? label.textContent : ''}
            <span data-id="${cb.id}">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                <path d="M8.35596 2.49609L2.33984 8.51221" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.35596 8.51221L2.33984 2.49609" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          `;
          container.appendChild(tag);
        });

        const clearAll = document.createElement('span');
        clearAll.className = 'clear-all';
        clearAll.textContent = 'CLEAR ALL FILTERS';
        container.appendChild(clearAll);

        container.style.display = 'flex';
      };

      // Add to desktop container
      addToContainer(activeFiltersContainer);
      
      // Add to mobile container
      if (activeFiltersMobile) {
        addToContainer(activeFiltersMobile);
      }
    };

    const handleFilterChange = (opts = {}) => {
      const { clearAll = false, searchTerm = '' } = opts;
      const perPageEl = document.getElementById('product-count-select');
      // When category or any filter changes, reset per-page to default batch size
      if (perPageEl) {
        perPageEl.value = '20';
      }

      const formData = new FormData(form);

      // Store the search term
      currentSearchTerm = searchTerm;

      if (clearAll) {
        // Remove implicit category constraint when clearing all filters
        formData.delete('category[]');
        currentSearchTerm = '';
      }
      
      // Add search term if provided
      if (searchTerm) {
        formData.append('search', searchTerm);
      }
      
      formData.append('action', 'filter_products');
      formData.append('nonce', (typeof customPagination !== 'undefined' && customPagination.filter_products_nonce) ? customPagination.filter_products_nonce : '');
      formData.append('per_page', (perPageEl && perPageEl.value) ? perPageEl.value : '20');

      loader.style.display = 'block';

      fetch(form.dataset.url, {
        method: 'POST',
        body: formData
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            results.innerHTML = data.data.html;
            // Use total matching products for the current filters,
            // not just the number of products currently visible.
            const total = (data.data && typeof data.data.total !== 'undefined') ? data.data.total : 0;
            productCount.textContent = total;
            renderActiveFilters();
            const perPage = (perPageEl && perPageEl.value) ? parseInt(perPageEl.value, 10) : 20;
            if (typeof window.customPagination !== 'undefined') {
              window.customPagination.total_posts = total;
            }
            document.dispatchEvent(new CustomEvent('productFiltersUpdated'));
            const paginatorWrap = document.getElementById('custom-paginator-wrap');
            if (paginatorWrap) {
              paginatorWrap.style.display = total > perPage ? '' : 'none';
            }
          } else {
            results.innerHTML = '<p class="label-1 mb-20">No products found.</p>';
            productCount.textContent = '0';
            if (typeof window.customPagination !== 'undefined') {
              window.customPagination.total_posts = 0;
            }
            document.dispatchEvent(new CustomEvent('productFiltersUpdated'));
            const paginatorWrap = document.getElementById('custom-paginator-wrap');
            if (paginatorWrap) paginatorWrap.style.display = 'none';
          }
        })
        .catch(err => {
          console.error('Filtering failed:', err);
          results.innerHTML = '<p class="label-1 mb-20">Error loading products.</p>';
          productCount.textContent = '0';
        })
        .finally(() => {
          loader.style.display = 'none';
        });

      const params = new URLSearchParams();
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
        const name = cb.name.replace('[]', '');
        params.append(name, cb.value);
      });
      // Add search term to URL if exists
      if (currentSearchTerm) {
        params.append('search', currentSearchTerm);
      }
      const newUrl = window.location.pathname + (params.toString() ? ('?' + params.toString()) : '');
      history.replaceState(null, '', newUrl);
    };

    form.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[type="checkbox"]')) {
        const group = e.target.closest('.filter-group');
        if (group) collapseGroup(group);
        handleFilterChange();
      }
    });

    activeFiltersContainer.addEventListener('click', function (e) {
      const closeBtn = e.target.closest('[data-id]');
      if (closeBtn) {
        const checkbox = document.getElementById(closeBtn.dataset.id);
        if (checkbox) {
          checkbox.checked = false;
          const group = checkbox.closest('.filter-group');
          if (group) collapseGroup(group);
          handleFilterChange();
        }
      } else if (e.target.classList.contains('clear-all')) {
        form.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
        // Clear search input if exists
        const searchInput = document.querySelector('#product-search-input');
        if (searchInput) {
          searchInput.value = '';
        }
        handleFilterChange({ clearAll: true });
        filterGroups.forEach(group => collapseGroup(group));
      } else if (e.target.closest('.close-search-btn')) {
        // Clear search
        currentSearchTerm = '';
        const searchInput = document.querySelector('#product-search-input');
        if (searchInput) {
          searchInput.value = '';
        }
        // Reload all products
        form.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
        
        // Remove search parameter from URL
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete('search');
        const newUrl = window.location.pathname + (urlParams.toString() ? ('?' + urlParams.toString()) : '');
        history.replaceState(null, '', newUrl);
        
        handleFilterChange({ clearAll: true });
      }
    });

    // Mobile active filters click handler
    const activeFiltersMobile = document.getElementById('active-filters-mobile');
    if (activeFiltersMobile) {
      activeFiltersMobile.addEventListener('click', function (e) {
        const closeBtn = e.target.closest('[data-id]');
        if (closeBtn) {
          const checkbox = document.getElementById(closeBtn.dataset.id);
          if (checkbox) {
            checkbox.checked = false;
            const group = checkbox.closest('.filter-group');
            if (group) collapseGroup(group);
            handleFilterChange();
          }
        } else if (e.target.classList.contains('clear-all')) {
          form.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
          // Clear search input if exists
          const searchInput = document.querySelector('#product-search-input');
          if (searchInput) {
            searchInput.value = '';
          }
          handleFilterChange({ clearAll: true });
          filterGroups.forEach(group => collapseGroup(group));
        } else if (e.target.closest('.close-search-btn')) {
          // Clear search
          currentSearchTerm = '';
          const searchInput = document.querySelector('#product-search-input');
          if (searchInput) {
            searchInput.value = '';
          }
          // Reload all products
          form.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
          
          // Remove search parameter from URL
          const urlParams = new URLSearchParams(window.location.search);
          urlParams.delete('search');
          const newUrl = window.location.pathname + (urlParams.toString() ? ('?' + urlParams.toString()) : '');
          history.replaceState(null, '', newUrl);
          
          handleFilterChange({ clearAll: true });
        }
      });
    }

    const urlParams = new URLSearchParams(window.location.search);
    const isAllProductsPage = window.location.pathname.indexOf('/all-products/') !== -1;
    const isMobileViewport = window.matchMedia('(max-width: 768px)').matches;
    const skipInitialUrlFilters = isAllProductsPage && isMobileViewport;
    let filtersExist = false;

    // Check for search parameter in URL
    const urlSearchTerm = urlParams.get('search');
    if (!skipInitialUrlFilters && urlSearchTerm) {
      currentSearchTerm = urlSearchTerm;
      filtersExist = true;
    }

    if (!skipInitialUrlFilters) {
      urlParams.forEach((value, key) => {
        // Skip 'search' parameter as it's handled separately
        if (key === 'search') return;
        
        const checkbox = form.querySelector(`input[name="${key}[]"][value="${value}"]`);
        if (checkbox) {
          checkbox.checked = true;
          filtersExist = true;
        }
      });
    }

    if (filtersExist) {
      // Pass search term if it exists in URL
      if (urlSearchTerm) {
        handleFilterChange({ searchTerm: urlSearchTerm });
      } else {
        handleFilterChange();
      }
    } else {
      // If arriving on a category archive where the category checkbox is already checked
      // show the active filters tags without forcing an initial AJAX reload
      const initiallyChecked = form.querySelectorAll('input[type="checkbox"]:checked').length > 0;
      if (initiallyChecked) {
        renderActiveFilters();
      }
    }

    // Populate search input if search term exists in URL
    if (!skipInitialUrlFilters && urlSearchTerm) {
      const searchInput = document.querySelector('#product-search-input');
      if (searchInput) {
        searchInput.value = urlSearchTerm;
      }
    }

    // Handle search input - only search on Enter key
    const searchInput = document.querySelector('#product-search-input');
    if (searchInput) {
      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          const searchTerm = e.target.value.trim();
          handleFilterChange({ searchTerm: searchTerm });
          
          // Close search field after search
          const searchContainer = document.querySelector('.product-search');
          const searchToggle = document.querySelector('.product-search-toggle');
          if (searchContainer && searchContainer.classList.contains("expanded")) {
            setTimeout(() => {
              searchContainer.classList.remove("expanded");
              if (searchToggle) searchToggle.classList.remove("active");
            }, 100);
          }
        }
      });
    }
  });
})();

// Wishlist state store + optimistic actions (single source of truth)
jQuery(function ($) {
  var wishlistAjaxUrl = (typeof mciWishlist !== 'undefined' && mciWishlist.ajax_url) ? mciWishlist.ajax_url : '';
  var wishlistNonce = (typeof mciWishlist !== 'undefined' && mciWishlist.nonce) ? mciWishlist.nonce : '';
  var wishlistEmptyUrl = (typeof mciWishlist !== 'undefined' && mciWishlist.empty_cart_url) ? mciWishlist.empty_cart_url : (window.location.origin + '/empty-cart/');
  if (!wishlistAjaxUrl || !wishlistNonce) return;

  var STORAGE_KEY = 'mci_wishlist_state_v1';
  var store = { count: 0, productIds: [], cartHtml: '', updatedAt: 0 };
  var listeners = [];
  var inFlightStatus = false;
  var pendingMutations = 0;
  var pendingByProductId = {};
  var pendingActionByProductId = {};
  var cartHtmlDirty = false; // only replace cart HTML after a real add/remove mutation

  function isWishlistPage() {
    var b = document.body;
    if (!b) return false;
    return b.classList.contains('mci-wishlist-page')
      || b.classList.contains('page-template-template-wishlist')
      || b.classList.contains('page-template-template-wishlist-php');
  }

  function normalizeState(input) {
    var ids = Array.isArray(input.productIds) ? input.productIds : [];
    var unique = [];
    var seen = {};
    ids.forEach(function (id) {
      var n = parseInt(id, 10);
      if (!isNaN(n) && n > 0 && !seen[n]) {
        seen[n] = true;
        unique.push(n);
      }
    });
    var count = parseInt(input.count, 10);
    if (isNaN(count) || count < 0) count = unique.length;
    return {
      count: count,
      productIds: unique,
      // Never trust persisted cart HTML because WooCommerce remove links contain expiring nonces.
      cartHtml: typeof input.cartHtml === 'string' ? input.cartHtml : '',
      updatedAt: input.updatedAt || Date.now()
    };
  }

  function readStoredState() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      // Force fresh cart HTML from server on each page load/navigation.
      parsed.cartHtml = '';
      return normalizeState(parsed);
    } catch (e) {
      return null;
    }
  }

  function writeStoredState(next) {
    try {
      // Persist only stable state; do not persist cartHtml with nonce-bearing remove links.
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        count: next.count,
        productIds: next.productIds,
        updatedAt: next.updatedAt
      }));
    } catch (e) {}
  }

  function setState(patch) {
    store = normalizeState({
      count: typeof patch.count !== 'undefined' ? patch.count : store.count,
      productIds: typeof patch.productIds !== 'undefined' ? patch.productIds : store.productIds,
      cartHtml: typeof patch.cartHtml !== 'undefined' ? patch.cartHtml : store.cartHtml,
      updatedAt: Date.now()
    });
    writeStoredState(store);
    listeners.forEach(function (fn) { fn(store); });
  }

  function subscribe(fn) {
    listeners.push(fn);
    fn(store);
  }

  function applyHeaderCount(state) {
    $('#dynamic-cart-count').text('Wishlist (' + state.count + ')');
    $('#wishlist-header-icon').toggleClass('cart-header-hidden', state.count <= 0);
  }

  function setHeartUI($btn, isInWishlist) {
    if (isInWishlist) {
      $btn.addClass('is-in-cart');
      $btn.find('.heart-icon path').attr('fill', '#e63946').css('fill', '');
      $btn.find('.wishlist-text').text('Added to wishlist');
    } else {
      $btn.removeClass('is-in-cart');
      $btn.find('.heart-icon path').attr('fill', 'none').css('fill', 'none');
      $btn.find('.wishlist-text').text('Add to Wishlist');
    }
  }

  function applyHeartsFromState(state) {
    var idMap = {};
    state.productIds.forEach(function (id) { idMap[id] = true; });
    $('.heart-add-to-cart').each(function () {
      var $btn = $(this);
      var pid = parseInt($btn.data('product_id'), 10);
      setHeartUI($btn, !!idMap[pid]);
    });
  }

  function getWishlistContainer() {
    var $newRoot = $('.wishlist-cart-content');
    if ($newRoot.length) return $newRoot.first();

    // Backward-compatibility: migrate stale cached DOM that still has old root id.
    var $legacyRoot = $('#mci-wishlist-cart-root');
    if ($legacyRoot.length) {
      $legacyRoot.removeAttr('id').removeClass('mci-wishlist-cart-root').addClass('wishlist-cart-content');
      return $legacyRoot.first();
    }
    return $();
  }

  function applyWishlistHtml(state) {
    if (!isWishlistPage()) return;
    if (!state.cartHtml) return;
    if (!cartHtmlDirty) return; // skip on initial load — server-rendered HTML is already correct
    // Never apply cached cart HTML while a mutation is in flight — store.cartHtml can be stale
    // and would undo optimistic row removal before the server response arrives.
    if (pendingMutations > 0) return;
    var $root = getWishlistContainer();
    if ($root.length) $root.html(state.cartHtml);
    cartHtmlDirty = false;
  }

  function applyOptimisticWishlistRowRemoval(productId) {
    if (!isWishlistPage()) return;
    var $root = getWishlistContainer();
    if (!$root.length) return;

    $root.find('a.remove[data-product_id="' + productId + '"], a.remove[data-product-id="' + productId + '"]').closest('.cart-product-details').remove();

    if ($root.find('.cart-product-details').length === 0) {
      window.location.assign(wishlistEmptyUrl);
    }
  }

  function applyStateToUI(state) {
    applyHeaderCount(state);
    applyHeartsFromState(state);
    applyWishlistHtml(state);
  }

  function parseServerState(data) {
    return {
      count: data && typeof data.count !== 'undefined' ? data.count : store.count,
      productIds: data && Array.isArray(data.product_ids) ? data.product_ids : store.productIds,
      cartHtml: data && typeof data.cart_html === 'string' ? data.cart_html : (data && typeof data.html === 'string' ? data.html : store.cartHtml)
    };
  }

  function reconcileServerState(data) {
    var parsed = parseServerState(data);
    var idMap = {};

    (Array.isArray(parsed.productIds) ? parsed.productIds : []).forEach(function (id) {
      var n = parseInt(id, 10);
      if (!isNaN(n) && n > 0) idMap[n] = true;
    });

    Object.keys(pendingActionByProductId).forEach(function (key) {
      var pid = parseInt(key, 10);
      if (isNaN(pid) || pid <= 0) return;
      if (pendingActionByProductId[key] === 'mci_wishlist_add') {
        idMap[pid] = true;
      } else if (pendingActionByProductId[key] === 'mci_wishlist_remove') {
        delete idMap[pid];
      }
    });

    var reconciledIds = Object.keys(idMap).map(function (k) { return parseInt(k, 10); });
    var patch = {
      productIds: reconciledIds,
      count: reconciledIds.length
    };

    // Cart HTML can contain remove nonces; avoid applying it while local mutations are still pending.
    if (pendingMutations === 0) {
      patch.cartHtml = parsed.cartHtml;
    }

    return patch;
  }

  function fetchStatus(force) {
    var stale = (Date.now() - (store.updatedAt || 0)) > 8000;
    if (!force && !stale) return;
    if (pendingMutations > 0) return;
    if (inFlightStatus) return;
    inFlightStatus = true;

    var ids = [];
    $('.heart-add-to-cart').each(function () {
      var pid = parseInt($(this).data('product_id'), 10);
      if (!isNaN(pid) && pid > 0) ids.push(pid);
    });

    $.post(wishlistAjaxUrl, { action: 'mci_wishlist_status', product_ids: ids, nonce: wishlistNonce })
      .done(function (res) {
        if (pendingMutations > 0) return;
        if (res && res.success && res.data) {
          setState(reconcileServerState(res.data));
          if (isWishlistPage()) {
            $.post(wishlistAjaxUrl, { action: 'mci_wishlist_refresh_cart', nonce: wishlistNonce })
              .done(function (refreshRes) {
                if (pendingMutations > 0) return;
                if (refreshRes && refreshRes.success && refreshRes.data) {
                  setState(reconcileServerState(refreshRes.data));
                }
              });
          }
        }
      })
      .always(function () {
        inFlightStatus = false;
      });
  }

  function refreshWishlistSnapshot(force) {
    if (!isWishlistPage()) return;
    if (!force && pendingMutations > 0) return;

    if (pendingMutations > 0) {
      setTimeout(function () {
        refreshWishlistSnapshot(true);
      }, 120);
      return;
    }

    $.post(wishlistAjaxUrl, { action: 'mci_wishlist_refresh_cart', nonce: wishlistNonce })
      .done(function (res) {
        if (res && res.success && res.data) {
          // Allow HTML update on explicit navigation refresh (tab focus / pageshow)
          if (force) cartHtmlDirty = true;
          setState(reconcileServerState(res.data));
        }
      });
  }

  function runWishlistActionByProductId(productId, forcedAction, $triggerEl) {
    if (isNaN(productId) || productId <= 0) {
      if ($triggerEl && $triggerEl.length) $triggerEl.data('heart-ajax-loading', false);
      return;
    }
    if (pendingByProductId[productId]) {
      if ($triggerEl && $triggerEl.length) $triggerEl.data('heart-ajax-loading', false);
      return;
    }
    pendingByProductId[productId] = true;
    pendingMutations += 1;
    cartHtmlDirty = true;

    var inWishlist = store.productIds.indexOf(productId) !== -1;
    var action = forcedAction || (inWishlist ? 'mci_wishlist_remove' : 'mci_wishlist_add');
    pendingActionByProductId[productId] = action;
    var prev = { count: store.count, productIds: store.productIds.slice(), cartHtml: store.cartHtml };
    var nextIds = store.productIds.slice();
    var isRemove = action === 'mci_wishlist_remove';

    if (isRemove) {
      nextIds = nextIds.filter(function (id) { return id !== productId; });
      applyOptimisticWishlistRowRemoval(productId);
    } else {
      nextIds.push(productId);
    }

    setState({
      productIds: nextIds,
      count: isRemove ? Math.max(0, store.count - 1) : (store.count + 1),
      cartHtml: isRemove && isWishlistPage() ? '' : store.cartHtml
    });

    $.post(wishlistAjaxUrl, { action: action, product_id: productId, nonce: wishlistNonce, quantity: 1 })
      .done(function (res) {
        delete pendingActionByProductId[productId];
        if (res && res.success && res.data) {
          var nextState = reconcileServerState(res.data);
          setState(nextState);
          // reconcileServerState guards cartHtml behind pendingMutations === 0, but
          // pendingMutations hasn't decremented yet here (.always runs after .done).
          // Apply returned cart_html directly for removes so the DOM is correct immediately.
          if (isRemove && isWishlistPage() && res.data.cart_html) {
            var $root = getWishlistContainer();
            if ($root.length) {
              $root.html(res.data.cart_html);
              cartHtmlDirty = false;
              setState({ cartHtml: res.data.cart_html });
            }
          }
          if (isRemove && isWishlistPage() && nextState.count <= 0) {
            window.location.assign(wishlistEmptyUrl);
          }
          return;
        }
        setState(prev);
      })
      .fail(function () {
        delete pendingActionByProductId[productId];
        setState(prev);
      })
      .always(function () {
        pendingMutations = Math.max(0, pendingMutations - 1);
        delete pendingByProductId[productId];
        if ($triggerEl && $triggerEl.length) $triggerEl.data('heart-ajax-loading', false);
        fetchStatus(false);
      });
  }

  function runWishlistAction($btn) {
    var productId = parseInt($btn.data('product_id'), 10);
    runWishlistActionByProductId(productId, null, $btn);
  }

  window.mciGetWishlistShareProductIds = function () {
    return store.productIds.slice();
  };

  var stored = readStoredState();
  if (stored) store = stored;
  subscribe(applyStateToUI);
  // Wishlist page must always reconcile with the server (avoids stale sessionStorage hiding a restored shared cart).
  fetchStatus(isWishlistPage() ? true : !stored);

  $(document.body).on('click', '.heart-add-to-cart', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var productId = parseInt($btn.data('product_id'), 10);
    if ($btn.data('heart-ajax-loading')) return;
    if (!isNaN(productId) && pendingByProductId[productId]) return;
    $btn.data('heart-ajax-loading', true);
    runWishlistAction($btn);
  });

  // Clear all wishlist items at once.
  $(document.body).on('click', '#wishlist-clear-all, #wishlist-clear-all-mobile', function (e) {
    if (!isWishlistPage()) return;
    e.preventDefault();
    var $btn = $(this);
    $btn.prop('disabled', true);
    $.post(wishlistAjaxUrl, { action: 'mci_wishlist_clear_all', nonce: wishlistNonce })
      .always(function () {
        try { window.sessionStorage.removeItem('mci_wishlist_state_v1'); } catch (e) {}
        window.location.reload();
      });
  });

  // Make wishlist row remove instant by using the same optimistic AJAX store flow.
  $(document.body).on('click', '.wishlist-cart-content a.remove, #mci-wishlist-cart-root a.remove', function (e) {
    if (!isWishlistPage()) return;
    e.preventDefault();
    var $link = $(this);
    var productId = parseInt(
      $link.attr('data-product_id') || $link.attr('data-product-id') || $link.data('product_id'),
      10
    );
    if (isNaN(productId) || productId <= 0) return;
    if (pendingByProductId[productId]) return;
    runWishlistActionByProductId(productId, 'mci_wishlist_remove', $link);
  });

  function syncFromNavigation() {
    var latest = readStoredState();
    if (latest) {
      store = latest;
      applyStateToUI(store);
    }
    // Wishlist page must always revalidate on navigation to avoid stale bfcache/cached HTML.
    if (isWishlistPage()) {
      refreshWishlistSnapshot(true);
      fetchStatus(true);
      return;
    }
    fetchStatus(false);
  }

  window.addEventListener('pageshow', syncFromNavigation);
  window.addEventListener('focus', syncFromNavigation);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') syncFromNavigation();
  });

  // Force a fresh document request whenever user navigates to Wishlist.
  // This avoids stale bfcache/history state on repeated back-and-forth navigation.
  $(document).on('click', 'a[href*="/wishlist"]', function (e) {
    // Respect new tab/window and modified clicks.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.which === 2) return;
    if (!this.href) return;

    var targetUrl;
    try {
      targetUrl = new URL(this.href, window.location.origin);
    } catch (err) {
      return;
    }

    if (targetUrl.pathname.indexOf('/wishlist') === -1) return;
    if (window.location.pathname === targetUrl.pathname && window.location.search === targetUrl.search) return;

    e.preventDefault();
    targetUrl.searchParams.set('_wl_refresh', String(Date.now()));
    window.location.assign(targetUrl.toString());
  });
});

// ===============================
// Single Product Collection Slider (Splide)
// ===============================
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const currentCollectionsSlider = document.querySelector('#current-collections-slider');
    if (!currentCollectionsSlider) return;

    new Splide(currentCollectionsSlider, {
        type   : 'loop',
        perPage: 4,
        gap    : '1rem',
        trimSpace: false,
        breakpoints: {
            992: { perPage: 3 },
            768: { 
                perPage: 2,
                padding: { right: '20%' }
            },
            576: { 
                perPage: 1,
                padding: { right: '20%' }
            },
        },
        autoplay: true,
        interval: 4000,
        pauseOnHover: true,
        arrows: false,
        pagination: false,
    }).mount();
  });
})();

// ===============================
// Single Product Projects Featuring Slider (Splide)
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const featuringSlider = document.querySelector(".single-product-projects-featuring");

    if (featuringSlider) {
      new Splide(featuringSlider, {
        updateOnMove: true,
        type: "loop",
        perPage: 3,
        perMove: 1,
        focus: "center",
        arrows: false,
        gap: '40px',
        pagination: false,
        autoplay: true,
        interval: 3000,
        speed: 1500,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
          767: {
            perPage: 1,
            padding: "10%",
            gap: "4px",
          },
          1024: {
            perPage: 2,
            padding: "15%",
          },
          1280: {
            perPage: 4,
          }
        }
      }).mount();
    }
  });
})();

// ===============================
// MCI Creation Products Featured Slider (Splide)
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const productsSlider = document.querySelector("#mci-creation-products-slider");
    if (!productsSlider) return;

    new Splide(productsSlider, {
      type: "loop",
      perPage: 4,
      perMove: 1,
      gap: "1rem",
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 3000,
      speed: 1000,
      pauseOnHover: false,
      pauseOnFocus: false,
      reducedMotion: {
        autoplay: true,
      },
      trimSpace: false,
      breakpoints: {
        992: { 
          perPage: 3,
        },
        768: { 
          perPage: 2,
          padding: { right: "20%" }
        },
        576: { 
          perPage: 1,
          padding: { right: "20%" }
        },
      },
    }).mount();
  });
})();

// ===============================
//Mci creation read more content
// ===============================
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const toggleBtn = document.querySelector('.read-more-toggle');
    const content = document.querySelector('.read-more-content');
    const label = toggleBtn ? toggleBtn.querySelector('.read-more-label') : null;

    // Ensure elements exist before attaching event listener
    if (toggleBtn && content && label) {
      toggleBtn.addEventListener('click', function () {
        const isExpanding = !content.classList.contains('expanded');

        if (isExpanding) {
          content.classList.add('expanded');
          content.classList.remove('collapsed');
          label.textContent = 'Read Less';
          this.setAttribute('aria-expanded', 'true');
        } else {
          content.classList.remove('expanded');
          content.classList.add('collapsed');
          label.textContent = 'Read More';
          this.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });
})();


// ===============================
// Media page tabs (All / Media / Awards) + open Awards when URL hash is #award
// ===============================
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const tabWrapper = document.querySelector('.insights_content_section .tab-wrapper');
    if (!tabWrapper) return;

    const tabMenu = tabWrapper.querySelector('.tab-menu');
    const tabItems = tabWrapper.querySelectorAll('.tab-items');
    const tabButtons = tabMenu ? tabMenu.querySelectorAll('li') : [];

    if (!tabMenu || !tabItems.length || !tabButtons.length) return;

    function showTab(index) {
      tabItems.forEach(function (item) { item.style.display = 'none'; });
      tabButtons.forEach(function (btn) { btn.classList.remove('tab-active'); });
      if (tabItems[index]) {
        tabItems[index].style.display = 'block';
        tabButtons[index].classList.add('tab-active');
      }
    }

    tabButtons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        showTab(index);
      });
    });

    // Helper to scroll to the tab section, offset by header height so it isn't hidden.
    function scrollToTabSection() {
      var section = document.querySelector('.insights_content_section');
      if (!section) return;
      var header = document.getElementById('header');
      var headerHeight = header ? header.offsetHeight : 80;
      var top = section.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        window.lenis.scrollTo(top, { duration: 0.8 });
      } else {
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    // Decide which tab to open based on the current hash
    function openTabFromHash(scroll) {
      const hash = (window.location.hash || '').toLowerCase().trim();

      // Prefer Awards when any "award" hash is present (e.g. #award, #awards, #award-section)
      if (hash && hash.indexOf('award') !== -1) {
        showTab(2);
        if (scroll) {
          setTimeout(scrollToTabSection, 50);
        }
        return;
      }

      // Media tab for any "media" hash (e.g. #media, #media-section)
      if (hash && hash.indexOf('media') !== -1) {
        showTab(1);
        if (scroll) {
          setTimeout(scrollToTabSection, 50);
        }
        return;
      }

      // Default to All
      showTab(0);
    }

    // Initial state (run twice to override any late scripts/styles)
    openTabFromHash(true);
    setTimeout(function () {
      openTabFromHash(false);
    }, 150);

    // React to hash changes (e.g. navigating within the page)
    window.addEventListener('hashchange', function () {
      openTabFromHash(false);
    });
  });
})();

//Media Load More Button
jQuery(document).ready(function ($) {
  $('.load-more-btn').on('click', function () {
      let btn = $(this);
      let originalHtml = btn.html();
      let offset = parseInt(btn.attr('data-offset'));
      let postType = btn.attr('data-post-type');
      let exclude = btn.attr('data-exclude');

      $.ajax({
          url: insights_ajax_obj.ajax_url,
          type: 'POST',
          dataType: 'json',
          data: {
              action: 'load_more_insights',
              nonce: insights_ajax_obj.nonce,
              offset: offset,
              postType: postType,
              exclude: exclude
          },
          beforeSend: function () {
              btn.text('Loading...');
          },
          success: function (res) {
              if (res.html) {
                  btn.closest('.tab-items').find('.insights_section_wrap').append(res.html);
                  offset += 6;
                  btn.attr('data-offset', offset);
                  btn.html(originalHtml);
                  if (!res.has_more) {
                      btn.replaceWith('<p class="label-1 no-more-posts">No more posts</p>');
                  }
              } else {
                  btn.replaceWith('<p class="label-1 no-more-posts">No more posts</p>');
              }
          },
          error: function () {
              btn.html(originalHtml); 
          }
      });
  });
});


// ===============================
// MCI Creation Banner Slider
// ===============================
document.addEventListener('DOMContentLoaded', function () {
  const banner = document.querySelector('.mci-creation-banner');
  if (!banner) return; // Prevent error if banner is missing

  const swiperContainer = banner.querySelector('.swiper-container');
  if (!swiperContainer) return; // Prevent error if swiper container is missing

  const paginationContainer = banner.querySelector('.custom-pagination');

  // Clear existing pagination
  if (paginationContainer) paginationContainer.innerHTML = '';

  const slides = swiperContainer.querySelectorAll('.swiper-slide');
  const thumbs = [];

  if (paginationContainer && slides.length) {
    slides.forEach((slide, index) => {
      const img = slide.querySelector('img');
      if (!img) return;

      const button = document.createElement('button');
      button.setAttribute('type', 'button');
      button.setAttribute('data-index', index);
      const thumbSrc = img.getAttribute('data-thumb') || img.getAttribute('data-src') || img.getAttribute('src') || '';
      button.innerHTML = `<img src="${thumbSrc}" alt="thumb-${index + 1}" loading="lazy" decoding="async">`;

      paginationContainer.appendChild(button);
      thumbs.push(button);
    });
  }

  const swiper = new Swiper(swiperContainer, {
    loop: true,
    effect: 'slide',
    parallax: true,
    speed: 1000,
    autoplay: {
      delay: 1500,
      disableOnInteraction: false,
    },
    on: {
      init: function () {
        this.autoplay.start();
        updateActiveThumb(this.realIndex);
      },
      slideChange: function () {
        this.params.autoplay.delay = this.params.speed + 2000;
        updateActiveThumb(this.realIndex);
      },
    },
  });

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      swiper.slideToLoop(i);
    });
  });

  function updateActiveThumb(index) {
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('active-thumb', i === index);
    });
  }
});

// ===============================
// Product Filter Bar - Mobile (in flow initially, fixed at top after scroll until footer)
// ===============================
document.addEventListener("DOMContentLoaded", function () {
  const filterBar = document.querySelector(".product-filter-bar");
  const sentinel = document.querySelector(".product-filter-bar-sentinel");
  const archiveInner = document.querySelector(".products-archive-inner");
  const footer = document.querySelector(".footer-newsletter");
  const header = document.getElementById("header");

  if (!filterBar) return;

  const isMobile = window.innerWidth <= 768;
  if (!isMobile) {
    filterBar.classList.remove("hidden");
    return;
  }

  filterBar.classList.remove("hidden");

  /**
   * Keep filter bar tucked under the header when:
   * - We're on mobile
   * - The bar is in its fixed \"stuck\" state
   * - The header is currently visible (scrolling up, same logic as header hide/show)
   */
  const syncFilterBarOffsetWithHeader = () => {
    if (!header) {
      filterBar.style.removeProperty("--filter-bar-offset");
      return;
    }

    if (!filterBar.classList.contains("product-filter-bar--stuck")) {
      // When not stuck, ensure no extra offset is applied
      filterBar.style.setProperty("--filter-bar-offset", "0px");
      return;
    }

    const headerVisible =
      header.classList.contains("is-visible") &&
      !header.classList.contains("is-hidden");

    if (headerVisible) {
      const headerHeight = header.getBoundingClientRect().height || 0;
      filterBar.style.setProperty(
        "--filter-bar-offset",
        `${headerHeight}px`
      );
    } else {
      // Header is hidden while scrolling down – let the bar sit at the very top
      filterBar.style.setProperty("--filter-bar-offset", "0px");
    }
  };

  // When user scrolls past the bar (sentinel leaves top of viewport), make bar fixed; otherwise in flow
  if (sentinel && archiveInner) {
    const stickObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const top = entry.boundingClientRect.top;
          if (entry.isIntersecting) {
            filterBar.classList.remove("product-filter-bar--stuck");
            archiveInner.classList.remove("has-stuck-filter-bar");
          } else if (top < 0) {
            // Sentinel has scrolled past the top – stick the bar
            filterBar.classList.add("product-filter-bar--stuck");
            archiveInner.classList.add("has-stuck-filter-bar");
          } else {
            // Sentinel below viewport (e.g. page just loaded) – keep bar in flow
            filterBar.classList.remove("product-filter-bar--stuck");
            archiveInner.classList.remove("has-stuck-filter-bar");
          }
          // Whenever stickiness changes, re-sync its vertical offset with header state
          syncFilterBarOffsetWithHeader();
        });
      },
      { threshold: 0 }
    );
    stickObserver.observe(sentinel);
  }

  // Keep offset in sync as user scrolls (header hide/show is scroll-driven)
  window.addEventListener("scroll", syncFilterBarOffsetWithHeader, {
    passive: true,
  });
  window.addEventListener("resize", syncFilterBarOffsetWithHeader);

  // Hide bar when footer newsletter reaches top 20% of viewport (not as soon as it appears)
  if (footer) {
    const footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            filterBar.classList.add("hidden");
          } else {
            filterBar.classList.remove("hidden");
          }
        });
      },
      { threshold: 0, rootMargin: "-20% 0px 0px 0px" }
    );
    footerObserver.observe(footer);
  }

  // Initial sync in case page loads scrolled and header is already visible/hidden
  syncFilterBarOffsetWithHeader();
});

// ===============================
// Product Filter Open/Close
// ===============================
document.addEventListener("DOMContentLoaded", function () {
  const filterBarLink = document.querySelector(".product-filter-bar a:last-child");
  const searchBarLink = document.querySelector(".product-filter-bar a:first-child");
  const filterDropdown = document.querySelector(".product-filter-dropdown");
  const closeBtn = document.querySelector(".prod-filter-close");
  const form = document.getElementById("filters-form");
  const activeFiltersContainer = document.getElementById("active-filters");

  // Guard: if no dropdown exists, stop
  if (!filterDropdown) return;

  const openFilter = (mode) => {
    filterDropdown.classList.add("filter-show");
    document.body.classList.add("no-scroll");
    if (window.lenis) window.lenis.stop();

    const productFilters = document.querySelector(".product-filters");
    const productSearch = document.querySelector(".product-search");
    const productSearchToggle = document.querySelector(".product-search-toggle");

    if (mode === "filter") {
      // Show filters, hide search
      if (productFilters) productFilters.style.display = "flex";
      if (productSearch) productSearch.style.display = "none";
      if (productSearchToggle) productSearchToggle.style.display = "none";
    } else if (mode === "search") {
      // Show search, hide filters
      if (productFilters) productFilters.style.display = "none";
      if (productSearch) productSearch.style.display = "block";
      if (productSearchToggle) productSearchToggle.style.display = "block";
      
      // Focus the search input
      const searchInput = document.getElementById("product-search-input");
      if (searchInput) {
        setTimeout(() => {
          searchInput.focus();
        }, 300);
      }
    }
  };

  const closeFilter = () => {
    filterDropdown.classList.remove("filter-show");
    document.body.classList.remove("no-scroll");
    if (window.lenis) window.lenis.start();

    // Reset visibility for next time
    const productFilters = document.querySelector(".product-filters");
    const productSearch = document.querySelector(".product-search");
    const productSearchToggle = document.querySelector(".product-search-toggle");
    if (productFilters) productFilters.style.display = "";
    if (productSearch) productSearch.style.display = "";
    if (productSearchToggle) productSearchToggle.style.display = "";
  };

  // Open filter drawer - search button
  if (searchBarLink) {
    searchBarLink.addEventListener("click", function (e) {
      e.preventDefault();
      openFilter("search");
    });
  }

  // Open filter drawer - filter button
  if (filterBarLink) {
    filterBarLink.addEventListener("click", function (e) {
      e.preventDefault();
      openFilter("filter");
    });
  }

  // Close filter drawer via close button
  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      closeFilter();
    });
  }

  // Close filter drawer when selecting a checkbox
  if (form) {
    form.addEventListener("change", function (e) {
      if (e.target && e.target.matches('input[type="checkbox"]')) {
        closeFilter();
      }
    });
  }

  // Close filter drawer when clearing all filters
  if (activeFiltersContainer) {
    activeFiltersContainer.addEventListener("click", function (e) {
      if (e.target.classList.contains("clear-all")) {
        closeFilter();
      }
    });
  }

  // Optional: Close if clicking outside the filter area
  document.addEventListener("click", function (e) {
    if (
      filterDropdown.classList.contains("filter-show") &&
      !filterDropdown.contains(e.target) &&
      (!searchBarLink || !searchBarLink.contains(e.target)) &&
      (!filterBarLink || !filterBarLink.contains(e.target))
    ) {
      closeFilter();
    }
  });

  // Optional: Close on Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && filterDropdown.classList.contains("filter-show")) {
      closeFilter();
    }
  });
});

// ===============================
// Product Search Toggle
// ===============================
document.addEventListener("DOMContentLoaded", function () {
  const searchToggle = document.querySelector(".product-search-toggle");
  const searchContainer = document.querySelector(".product-search");
  const searchIcon = document.querySelector(".product-search-icon");

  if (!searchToggle || !searchContainer) return;

  // Function to close search
  const closeSearch = () => {
    searchContainer.classList.remove("expanded");
    searchToggle.classList.remove("active");
  };

  // Function to open search
  const openSearch = () => {
    searchContainer.classList.add("expanded");
    searchToggle.classList.add("active");
    const searchInput = searchContainer.querySelector("input");
    if (searchInput) {
      setTimeout(() => {
        searchInput.focus();
      }, 300);
    }
  };

  // Toggle button - expand/collapse search field
  searchToggle.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Check if already expanded, then close it
    if (searchContainer.classList.contains("expanded")) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  // Search icon inside input - trigger search and close
  if (searchIcon) {
    // Make the icon clickable
    searchIcon.style.pointerEvents = "auto";
    searchIcon.style.cursor = "pointer";
    
    searchIcon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      
      const searchInput = document.getElementById('product-search-input');
      if (searchInput) {
        const searchTerm = searchInput.value.trim();
        // Trigger Enter key event to perform search
        const enterEvent = new KeyboardEvent('keydown', {
          key: 'Enter',
          keyCode: 13,
          bubbles: true
        });
        searchInput.dispatchEvent(enterEvent);
        // Close after search
        closeSearch();
      }
      
      // Close the product-filter-dropdown on mobile
      const filterDropdown = document.querySelector(".product-filter-dropdown");
      if (filterDropdown && filterDropdown.classList.contains("filter-show")) {
        filterDropdown.classList.remove("filter-show");
        document.body.classList.remove("no-scroll");
        if (window.lenis) window.lenis.start();
        
        // Reset visibility for next time
        const productFilters = document.querySelector(".product-filters");
        const productSearch = document.querySelector(".product-search");
        const productSearchToggle = document.querySelector(".product-search-toggle");
        if (productFilters) productFilters.style.display = "";
        if (productSearch) productSearch.style.display = "";
        if (productSearchToggle) productSearchToggle.style.display = "";
      }
    });
  }

  // Close when clicking outside
  document.addEventListener('click', function(e) {
    if (searchContainer.classList.contains("expanded")) {
      // Check if click is outside search container and toggle button
      if (!searchContainer.contains(e.target) && !searchToggle.contains(e.target)) {
        closeSearch();
      }
    }
  });
});

// ===============================
// Product Layout Switcher - Mobile
// ===============================
document.addEventListener("DOMContentLoaded", function () {
  const grid = document.querySelector(".custom-products-grid");
  const singleBtn = document.querySelector(".layout-switcher .single-col");
  const doubleBtn = document.querySelector(".layout-switcher .double-col");
  const filterBar = document.querySelector(".product-filter-bar");

  if (grid && singleBtn && doubleBtn) {
    doubleBtn.classList.add("active");

    singleBtn.addEventListener("click", function () {
      grid.classList.add("single-col");
      singleBtn.classList.add("active");
      doubleBtn.classList.remove("active");
      // Ensure the mobile filter bar is visible when switching layouts
      if (filterBar) {
        filterBar.classList.remove("hidden");
      }
    });

    doubleBtn.addEventListener("click", function () {
      grid.classList.remove("single-col");
      doubleBtn.classList.add("active");
      singleBtn.classList.remove("active");
      if (filterBar) {
        filterBar.classList.remove("hidden");
      }
    });
  }
});

// ===============================
// Blog Pagination AJAX
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const blogContainer = document.querySelector('.insights_blog_wrap');
    const paginationContainer = document.querySelector('.pagination-wrapper');
    const pagination = document.querySelector('.pagination');
    
    if (!blogContainer || !paginationContainer || !pagination) {
      return; // Exit if required elements don't exist
    }

    // Blogs template only (AJAX links use data-page). Category archives use normal URLs.
    if (!pagination.querySelector('.pagination-link[data-page]')) {
      return;
    }

    // Get featured post ID from the data attribute
    let featuredPostId = 0;
    if (blogContainer) {
      featuredPostId = parseInt(blogContainer.getAttribute('data-featured-post-id')) || 0;
    }

    let isLoading = false;

    // Add loading state styles
    const loadingStyles = document.createElement('style');
    loadingStyles.textContent = `
      .blog-pagination-loading {
        opacity: 0.6;
        pointer-events: none;
        position: relative;
      }
      .blog-pagination-loading::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin: -10px 0 0 -10px;
        border: 2px solid #f3f3f3;
        border-top: 2px solid #232221;
        border-radius: 50%;
        animation: blog-pagination-spin 1s linear infinite;
      }
      @keyframes blog-pagination-spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(loadingStyles);

    function loadPage(page) {
      if (isLoading) return;
      
      isLoading = true;
      blogContainer.classList.add('blog-pagination-loading');

      const formData = new FormData();
      formData.append('action', 'blog_pagination');
      formData.append('page', page);
      formData.append('featured_post_id', featuredPostId);
      formData.append('nonce', blogPagination.nonce);

      fetch(blogPagination.ajax_url, {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          // Update blog posts
          blogContainer.innerHTML = data.data.html;
          
          // Update pagination
          if (data.data.pagination) {
            pagination.innerHTML = data.data.pagination;
          } else {
            paginationContainer.style.display = 'none';
          }

          // Update URL without page reload
          const url = new URL(window.location);
          if (page === 1) {
            url.searchParams.delete('paged');
          } else {
            url.searchParams.set('paged', page);
          }
          window.history.pushState({ page: page }, '', url);

          // Scroll to top of blog section
          const blogSection = document.querySelector('.insights_blog_wrap');
          if (blogSection) {
            blogSection.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'start' 
            });
          }
        } else {
          console.error('Blog pagination error:', data.data);
          // Show error message
          blogContainer.innerHTML = '<p class="label-1">Error loading blog posts. Please try again.</p>';
        }
      })
      .catch(error => {
        console.error('Blog pagination request failed:', error);
        blogContainer.innerHTML = '<p class="label-1">Error loading blog posts. Please try again.</p>';
      })
      .finally(() => {
        isLoading = false;
        blogContainer.classList.remove('blog-pagination-loading');
      });
    }

    // Handle pagination clicks
    pagination.addEventListener('click', function(e) {
      const link = e.target.closest('.pagination-link');
      if (!link || link.classList.contains('active')) return;

      const page = parseInt(link.getAttribute('data-page'), 10);
      if (!page || page < 1) return;

      e.preventDefault();
      loadPage(page);
    });

    // Handle browser back/forward buttons
    window.addEventListener('popstate', function(e) {
      if (e.state && e.state.page) {
        loadPage(e.state.page);
      } else {
        // Load first page if no state
        const urlParams = new URLSearchParams(window.location.search);
        const page = parseInt(urlParams.get('paged')) || 1;
        loadPage(page);
      }
    });

    // Initialize with current page from URL
    const urlParams = new URLSearchParams(window.location.search);
    const currentPage = parseInt(urlParams.get('paged')) || 1;
    
    // Set initial state
    window.history.replaceState({ page: currentPage }, '', window.location.href);
  });
})();

// ===============================
// Single Product Action Bar - Mobile
// ===============================
document.addEventListener("DOMContentLoaded", function() {
  const actionBar = document.querySelector(".product-action-bar");
  const footer = document.querySelector("footer"); 
  const isMobile = () => window.matchMedia("(max-width: 768px)").matches;
  
  if (!actionBar || !footer) return;

  function toggleActionBar() {
      // Only manage visibility on mobile; always show on desktop
      if (!isMobile()) {
        actionBar.classList.remove("hidden");
        return;
      }

      const footerRect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (footerRect.top < windowHeight) {
          actionBar.classList.add("hidden");
      } else {
          actionBar.classList.remove("hidden");
      }
  }

  window.addEventListener("scroll", toggleActionBar);
  window.addEventListener("resize", toggleActionBar); 
  toggleActionBar(); 
});

// ===============================
// Native Share API
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const nativeShareButtons = document.querySelectorAll('.native-share');
    
    if (nativeShareButtons.length === 0) return;

    nativeShareButtons.forEach(button => {
      button.addEventListener('click', async function(e) {
        e.preventDefault();
        
        const url = this.getAttribute('data-url');
        const title = this.getAttribute('data-title');
        const text = this.getAttribute('data-text');
        
        // Check if Web Share API is supported
        if (navigator.share) {
          try {
            await navigator.share({
              title: title,
              text: text,
              url: url
            });
          } catch (err) {
            // User cancelled the share or error occurred — nothing to do
          }
        } else {
          // Fallback: copy URL to clipboard
          try {
            await navigator.clipboard.writeText(url);
            // You could add a toast notification here
            alert('Link copied to clipboard!');
          } catch (err) {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = url;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            alert('Link copied to clipboard!');
          }
        }
      });
    });
  });
})();

// ===============================
// Phone number inputs: numbers only (no alphabets)
// ===============================
(function () {
  var phoneSelector = 'input[type="tel"], input[name="phone"]';

  function isPhoneInput(el) {
    return el && el.matches && el.matches(phoneSelector);
  }

  function allowKey(e) {
    var key = e.key;
    if (key.length === 1 && key >= '0' && key <= '9') return true;
    var controlKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    return controlKeys.indexOf(key) !== -1 || e.ctrlKey || e.metaKey;
  }

  function digitsOnly(value) {
    return (value || '').replace(/\D/g, '');
  }

  document.addEventListener('keydown', function (e) {
    if (!isPhoneInput(e.target)) return;
    if (!allowKey(e)) e.preventDefault();
  }, true);

  document.addEventListener('input', function (e) {
    if (!isPhoneInput(e.target)) return;
    var el = e.target;
    var start = el.selectionStart;
    var end = el.selectionEnd;
    var oldVal = el.value;
    var newVal = digitsOnly(oldVal);
    if (newVal !== oldVal) {
      el.value = newVal;
      var lenDiff = newVal.length - oldVal.length;
      var newEnd = Math.max(0, end + lenDiff);
      el.setSelectionRange(newEnd, newEnd);
    }
  }, true);
})();

// ===============================
// In-page scroll targets (footer Send enquiry on contact, etc.)
// ===============================
(function () {
  var scrollLock = false;

  function pinHeaderVisible() {
    var header = document.getElementById('header');
    if (!header) return;

    header.classList.remove('is-hidden');
    header.classList.add('is-visible');
  }

  function scrollToTarget(target, options) {
    if (!target) return;

    var immediate = options && options.immediate;
    var behavior = immediate ? 'auto' : 'smooth';

    pinHeaderVisible();

    // scroll-margin-top on the target handles fixed-header clearance (see _contact.scss).
    if (typeof target.scrollIntoView === 'function') {
      try {
        target.scrollIntoView({ behavior: behavior, block: 'start' });
        return;
      } catch (_) {
        // Fallback below for older browsers.
      }
    }

    window.scrollTo({
      top: Math.max(target.getBoundingClientRect().top + window.scrollY, 0),
      behavior: behavior,
    });
  }

  function updateHash(targetId) {
    if (!targetId || !window.history || !window.history.replaceState) return;

    var nextUrl = window.location.pathname + window.location.search + '#' + targetId;
    if (window.location.pathname + window.location.search + window.location.hash === nextUrl) return;

    window.history.replaceState(null, '', nextUrl);
  }

  function runAfterScroll(callback) {
    var done = false;

    function finish() {
      if (done) return;
      done = true;
      callback();
    }

    if ('onscrollend' in window) {
      window.addEventListener('scrollend', finish, { once: true });
    }

    setTimeout(finish, 900);
  }

  function isContactPage() {
    return document.body.classList.contains('page-template-template-contact')
      || /\/contact\/?$/.test(window.location.pathname);
  }

  var CONTACT_SCROLL_EXTRA = 100;

  function getHeaderOffset() {
    var header = document.getElementById('header');
    if (!header) return 100;

    return header.offsetHeight || 100;
  }

  function getContactScrollTop() {
    var target = document.querySelector('.contact-banner');
    if (!target) return 0;

    var offset = getHeaderOffset() + CONTACT_SCROLL_EXTRA;
    return Math.max(target.getBoundingClientRect().top + window.scrollY - offset, 0);
  }

  function scrollToContactTop(options) {
    var immediate = options && options.immediate;
    var behavior = immediate ? 'auto' : 'smooth';

    window.scrollTo({ top: getContactScrollTop(), behavior: behavior });
  }

  function hideHeader() {
    var header = document.getElementById('header');
    if (!header) return;

    header.classList.remove('is-visible');
    header.classList.add('is-hidden');
  }

  function clearPageHash() {
    if (!window.history || !window.history.replaceState) return;

    var cleanUrl = window.location.pathname + window.location.search;
    if (window.location.pathname + window.location.search + window.location.hash === cleanUrl) return;

    window.history.replaceState(null, '', cleanUrl);
  }

  document.addEventListener('click', function (event) {
    var footerEnquiry = event.target.closest('[data-footer-enquiry]');
    if (footerEnquiry) {
      if (!isContactPage()) {
        return;
      }

      event.preventDefault();
      if (scrollLock) return;

      var contactUrl = footerEnquiry.getAttribute('href') || window.location.pathname;
      var contactScrollTop = getContactScrollTop();

      if (Math.abs(window.scrollY - contactScrollTop) <= 10) {
        window.location.href = contactUrl;
        return;
      }

      scrollLock = true;
      scrollToContactTop();

      runAfterScroll(function () {
        clearPageHash();
        scrollLock = false;
      });

      return;
    }
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-scroll-target]');
    if (!trigger) return;

    var targetId = trigger.getAttribute('data-scroll-target');
    if (!targetId) return;

    var target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    if (scrollLock) return;

    scrollLock = true;
    scrollToTarget(target);

    runAfterScroll(function () {
      updateHash(targetId);
      scrollLock = false;
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var target = document.getElementById(hash.slice(1));
    if (!target) return;

    requestAnimationFrame(function () {
      scrollToTarget(target, { immediate: true });
    });
  });
})();

